(() => {
'use strict';
/* ============================================================
   AKKUNAUT – CHARGE & RUN
   Interne Auflösung 384×216, scharf hochskaliert (16-Bit-Look).
   Alle Grafiken werden beim Start im Code gezeichnet – keine Bilddateien.
   Shop-Fassung (AKKURANDO 2.1, sections/akk-game.liquid, Präfix akg):
   – arbeitet nur innerhalb von [data-akg]; Tasten greifen nur, wenn das Spiel den Fokus hat oder läuft
   – pausiert, sobald das Spielfeld aus dem Bild gescrollt wird, und rechnet dann nicht weiter
   – Bestenliste: ohne data-lb-url lokal im Browser, mit data-lb-url gemeinsam über einen Server (GET/POST JSON)
   – data-mode="404": Titelbild meldet „Fehler 404“ (404-Seite im Chrome-Dino-Stil)
   – window.AKG.play(): öffnet das Spiel im Vollbild (Footer-Startknopf, snippets/akk-footer-game.liquid)
   ============================================================ */
const W = 384, H = 216, GROUND = 196;
const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
const C = {
  k:'#040a14', n0:'#071526', n1:'#0b1d33', n2:'#0f2a45', n3:'#16385a', n4:'#21507a', rim:'#3a6f99',
  N:'#1f3d5c', L:'#3c6688', nd:'#132a42',
  o:'#ff4c29', o2:'#ff8a5c', od:'#c2341a', amb:'#ffb24a', cream:'#ffe3c4', w:'#f2f7fc',
  g:'#8fa7bd', gl:'#c9d6e2', gd:'#4c6378', e:'#59dcff', ew:'#e4fbff', r:'#ff2e4d', rd:'#8c1428',
  V:'#08131f', F:'#ffcf9e'
};
const root = document.querySelector('[data-akg]');
if (!root || root.dataset.akgReady) return;
root.dataset.akgReady = '1';
/* Elemente per data-akg-el suchen – seitenweit, weil das Spielfeld im Vollbild an <body> umzieht (nur ein Spiel pro Seite) */
const $ = (id) => document.querySelector('[data-akg-el="' + id + '"]');
const MODE = root.dataset.mode || '';
const cv = $('game');
const ctx = cv.getContext('2d');
ctx.imageSmoothingEnabled = false;

function mk(w, h){ const c = document.createElement('canvas'); c.width = w; c.height = h; const x = c.getContext('2d'); x.imageSmoothingEnabled = false; return [c, x]; }
function rng(seed){ return () => { seed |= 0; seed = seed + 0x6D2B79F5 | 0; let t = Math.imul(seed ^ seed >>> 15, 1 | seed); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }
const R0 = Math.random;
const rnd = (a, b) => a + R0() * (b - a);
const pick = (arr) => arr[Math.floor(R0() * arr.length)];
const fmt = (n) => Math.floor(n).toLocaleString('de-DE');
const clamp = (v, a, b) => v < a ? a : v > b ? b : v;

/* ---------- Pixel-Schrift 5×7 ---------- */
const FONT = {
  A:[14,17,17,31,17,17,17],B:[30,17,17,30,17,17,30],C:[14,17,16,16,16,17,14],D:[30,17,17,17,17,17,30],
  E:[31,16,16,30,16,16,31],F:[31,16,16,30,16,16,16],G:[14,17,16,23,17,17,15],H:[17,17,17,31,17,17,17],
  I:[14,4,4,4,4,4,14],J:[7,2,2,2,2,18,12],K:[17,18,20,24,20,18,17],L:[16,16,16,16,16,16,31],
  M:[17,27,21,21,17,17,17],N:[17,25,21,19,17,17,17],O:[14,17,17,17,17,17,14],P:[30,17,17,30,16,16,16],
  Q:[14,17,17,17,21,18,13],R:[30,17,17,30,20,18,17],S:[15,16,16,14,1,1,30],T:[31,4,4,4,4,4,4],
  U:[17,17,17,17,17,17,14],V:[17,17,17,17,17,10,4],W:[17,17,17,21,21,21,10],X:[17,17,10,4,10,17,17],
  Y:[17,17,10,4,4,4,4],Z:[31,1,2,4,8,16,31],'Ä':[10,0,14,17,31,17,17],'Ö':[10,0,14,17,17,17,14],'Ü':[10,0,17,17,17,17,14],
  0:[14,19,21,21,25,17,14],1:[4,12,4,4,4,4,14],2:[14,17,1,2,4,8,31],3:[31,2,4,2,1,17,14],4:[2,6,10,18,31,2,2],
  5:[31,16,30,1,1,17,14],6:[6,8,16,30,17,17,14],7:[31,1,2,4,8,8,8],8:[14,17,17,14,17,17,14],9:[14,17,17,15,1,2,12],
  ' ':[0,0,0,0,0,0,0],'.':[0,0,0,0,0,12,12],',':[0,0,0,0,12,4,8],'!':[4,4,4,4,4,0,4],'?':[14,17,1,2,4,0,4],
  ':':[0,12,12,0,12,12,0],'-':[0,0,0,31,0,0,0],'+':[0,4,4,31,4,4,0],'/':[1,1,2,4,8,16,16],'%':[24,25,2,4,8,19,3],
  '&':[12,18,20,8,21,18,13],"'":[4,4,8,0,0,0,0],'(':[2,4,8,8,8,4,2],')':[8,4,2,2,2,4,8],'#':[10,10,31,10,31,10,10],
  '×':[0,17,10,4,10,17,0],'>':[8,4,2,1,2,4,8],'<':[2,4,8,16,8,4,2],'_':[0,0,0,0,0,0,31],'=':[0,0,31,0,31,0,0],'·':[0,0,0,12,12,0,0]
};
function glyphs(x, s, px, py, col, sc){
  x.fillStyle = col;
  for (let i = 0; i < s.length; i++){
    const g = FONT[s[i]] || FONT['?'];
    for (let r = 0; r < 7; r++){ const row = g[r]; if (!row) continue;
      for (let b = 0; b < 5; b++) if (row & (16 >> b)) x.fillRect(px + (i * 6 + b) * sc, py + r * sc, sc, sc); }
  }
}
const tcache = new Map();
function tex(s, col, sc = 1, glow = null){
  s = String(s).toUpperCase();
  const k = s + '|' + col + '|' + sc + '|' + glow;
  let c = tcache.get(k); if (c) return c;
  const pad = glow ? 5 : 0;
  const [cc, x] = mk(Math.max(1, s.length * 6 * sc - sc) + pad * 2, 7 * sc + pad * 2);
  if (glow){ x.shadowColor = glow; x.shadowBlur = 5; glyphs(x, s, pad, pad, col, sc); x.shadowBlur = 0; }
  glyphs(x, s, pad, pad, col, sc);
  if (tcache.size > 500) tcache.clear();
  tcache.set(k, cc); return cc;
}
function T(s, x, y, col, sc = 1, glow = null, align = 'l', alpha = 1){
  const c = tex(s, col, sc, glow), pad = glow ? 5 : 0, tw = c.width - pad * 2;
  let dx = x; if (align === 'c') dx = x - tw / 2; else if (align === 'r') dx = x - tw;
  if (alpha < 1) ctx.globalAlpha = alpha;
  ctx.drawImage(c, Math.round(dx - pad), Math.round(y - pad));
  if (alpha < 1) ctx.globalAlpha = 1;
}

/* ---------- Pixel-Raster zum Zeichnen von Figuren ---------- */
function grid(w, h){
  const P = new Array(w * h).fill(0);
  const G = {
    w, h, P,
    set(x, y, c){ x = Math.round(x); y = Math.round(y); if (x >= 0 && y >= 0 && x < w && y < h) P[y * w + x] = c; },
    get(x, y){ return (x < 0 || y < 0 || x >= w || y >= h) ? 0 : P[y * w + x]; },
    rect(x, y, ww, hh, c){ for (let j = 0; j < hh; j++) for (let i = 0; i < ww; i++) G.set(x + i, y + j, c); },
    disc(cx, cy, r, c){
      for (let y = Math.floor(cy - r - 1); y <= Math.ceil(cy + r + 1); y++)
        for (let x = Math.floor(cx - r - 1); x <= Math.ceil(cx + r + 1); x++){
          const dx = x - cx, dy = y - cy;
          if (dx * dx + dy * dy <= r * r) G.set(x, y, typeof c === 'function' ? c(dx, dy) : c);
        }
    },
    line(x0, y0, x1, y1, r, c){ const n = Math.ceil(Math.hypot(x1 - x0, y1 - y0) * 2) + 1; for (let i = 0; i <= n; i++){ const t = i / n; G.disc(x0 + (x1 - x0) * t, y0 + (y1 - y0) * t, r, c); } },
    map(rows, ox, oy, pal){ rows.forEach((row, j) => { for (let i = 0; i < row.length; i++){ const ch = row[i]; if (ch !== '.' && pal[ch]) G.set(ox + i, oy + j, pal[ch]); } }); },
    outline(c){ const add = []; for (let y = 0; y < h; y++) for (let x = 0; x < w; x++){ if (P[y * w + x]) continue; if (G.get(x - 1, y) || G.get(x + 1, y) || G.get(x, y - 1) || G.get(x, y + 1)) add.push(y * w + x); } add.forEach(i => P[i] = c); },
    canvas(){ const [c, x] = mk(w, h); const id = x.createImageData(w, h);
      for (let i = 0; i < w * h; i++){ const col = P[i]; if (!col) continue; const v = parseInt(col.slice(1), 16);
        id.data[i * 4] = v >> 16; id.data[i * 4 + 1] = (v >> 8) & 255; id.data[i * 4 + 2] = v & 255; id.data[i * 4 + 3] = 255; }
      x.putImageData(id, 0, 0); return c; }
  };
  return G;
}

/* ---------- Der Akkunaut (nach dem Maskottchen vom Blister) ---------- */
const AK_W = 30, AK_H = 28;
const akCache = new Map();
function akkunaut(face, pose){
  const key = face + '|' + pose; let c = akCache.get(key); if (c) return c;
  const G = grid(AK_W, AK_H);
  const shade = (dx, dy) => (dx + dy < -5 ? C.L : dx + dy > 5 ? C.nd : C.N);
  const orange = (dx, dy) => (dy > 0.8 ? C.od : (dx < -0.4 && dy < 0 ? C.o2 : C.o));
  // Flosse am Helm
  G.rect(7, 2, 2, 4, C.o); G.set(8, 1, C.o2); G.rect(9, 3, 2, 3, C.o); G.set(7, 2, C.o2);
  // Jetpack
  G.rect(4, 11, 6, 10, C.gd); G.rect(5, 12, 1, 8, C.g); G.rect(4, 14, 6, 1, C.o);
  G.set(8, 16, C.amb); G.set(8, 18, C.amb); G.rect(5, 21, 4, 2, '#2b3a4a');
  // Beine
  const leg = (x0, y0, x1, y1, bx, by, bw) => { G.line(x0, y0, x1, y1, 1.3, C.N); G.rect(bx, by, bw, 2, C.o); G.rect(bx, by + 1, bw, 1, C.od); };
  if (pose === 'run0'){ leg(12, 20, 10, 24, 8, 24, 4); leg(15, 20, 17, 24, 16, 24, 4); }
  else if (pose === 'run1'){ leg(12, 20, 13, 24, 12, 24, 4); leg(15, 20, 12, 23, 10, 23, 3); }
  else if (pose === 'fall'){ leg(12, 20, 9, 23, 7, 22, 3); leg(15, 20, 18, 23, 17, 22, 3); }
  else { leg(13, 20, 9, 24, 6, 24, 4); leg(15, 21, 12, 25, 10, 25, 3); }
  // Körper
  G.disc(13, 17, 4.8, shade);
  G.rect(9, 20, 8, 1, C.od);
  G.disc(14, 17, 1.9, orange); G.set(15, 16, C.cream); G.set(14, 17, C.cream); G.set(13, 18, C.cream);
  // Arm + Handschuh
  if (pose === 'fall'){ G.line(16, 15, 19, 11, 1.2, C.N); G.disc(20, 10, 2.1, orange); }
  else { G.line(16, 16, 20, 15, 1.2, C.N); G.disc(22, 15, 2.2, orange); }
  // Kopf
  G.disc(14, 9, 7.5, (dx, dy) => (dx + dy < -7 ? C.L : dx + dy > 6 ? C.nd : C.N));
  G.disc(8.6, 10, 2, orange); G.set(8, 10, C.cream); G.set(9, 9, C.cream);
  // Visier mit orangem Ring
  G.disc(17.2, 9, 5.6, orange);
  G.disc(17.6, 9, 4.5, (dx, dy) => (dx + dy > 3 ? '#0e2236' : C.V));
  G.set(15, 6, '#2c4d6e'); G.set(14, 7, '#1d3954');
  // LED-Gesicht
  const F = C.F, FB = '#fff1dd';
  const px = (pts) => pts.forEach(p => G.set(p[0], p[1], p[2] || F));
  if (face === 'happy'){ px([[15,8],[16,7,FB],[17,8],[19,8],[20,7,FB],[21,8],[15,10],[16,11],[17,11,FB],[18,11,FB],[19,11],[20,10]]); }
  else if (face === 'worry'){ px([[15,8],[16,8,FB],[19,8,FB],[20,8],[15,7],[20,7],[16,11],[17,11],[18,11],[19,10]]); }
  else if (face === 'sad'){ px([[15,8],[16,8],[19,8],[20,8],[16,11],[17,10],[18,10],[19,11]]); }
  else if (face === 'hit'){ px([[14,6],[16,6],[15,7,FB],[14,8],[16,8],[18,6],[20,6],[19,7,FB],[18,8],[20,8],[17,10],[18,10],[17,11],[18,11]]); }
  else if (face === 'wow'){ px([[15,7],[16,7,FB],[15,8],[16,8],[19,7,FB],[20,7],[19,8],[20,8],[17,10],[18,10,FB],[17,11],[18,11]]); }
  else { px([[15,7],[16,7,FB],[15,8],[16,8],[19,7,FB],[20,7],[19,8],[20,8],[15,10],[16,11],[17,11,FB],[18,11],[19,11],[20,10]]); }
  // Streiflicht von oben (Stadtlicht), damit er sich vom Nachthimmel abhebt
  const body = new Set([C.N, C.L, C.nd]), rim = [];
  for (let y = 0; y < AK_H; y++) for (let x = 0; x < AK_W; x++){ const v = G.get(x, y); if (body.has(v) && !G.get(x, y - 1)) rim.push([x, y, '#6c9cc6']); else if (body.has(v) && !G.get(x - 1, y) && y > 8) rim.push([x, y, '#3f6f99']); }
  rim.forEach(([x, y, c2]) => G.set(x, y, c2));
  G.outline(C.k);
  c = G.canvas(); akCache.set(key, c); return c;
}

/* ---------- Batterien (Sammelobjekte) ---------- */
const BAT = {
  cr2032:{ name:'CR2032', label:'Knopfzelle CR2032', mah:225,   pct:2, w:11, h:11 },
  aaa:   { name:'AAA',    label:'AAA Micro',          mah:1200,  pct:5,   w:7,  h:14 },
  aa:    { name:'AA',     label:'AA Mignon',          mah:2850,  pct:9,  w:8,  h:17 },
  v9:    { name:'9V',     label:'9V-Block',           mah:550,   pct:7,   w:11, h:15, boost:1.4 },
  c:     { name:'C',      label:'C Baby',             mah:8000,  pct:18,  w:11, h:17 },
  d:     { name:'D',      label:'D Mono',             mah:17000, pct:30,  w:13, h:21 }
};
function cylSprite(bw, bh){
  const G = grid(bw + 2, bh + 2), ox = 1, oy = 1;
  const cw = Math.max(2, Math.round(bw / 3)), cx = ox + Math.floor((bw - cw) / 2);
  G.rect(cx, oy, cw, 1, C.gl); G.rect(cx, oy + 1, cw, 1, C.g);
  for (let y = oy + 2; y < oy + bh; y++) for (let x = ox; x < ox + bw; x++) G.set(x, y, x === ox ? C.L : x === ox + bw - 1 ? C.nd : C.N);
  G.rect(ox, oy + 2, bw, 1, C.g); G.set(ox, oy + 2, C.gl); G.rect(ox, oy + bh - 1, bw, 1, C.gd);
  const by = oy + Math.round(bh * 0.42), bhh = Math.max(2, Math.round(bh * 0.24));
  for (let y = by; y < by + bhh; y++) for (let x = ox; x < ox + bw; x++) G.set(x, y, x === ox ? C.o2 : x === ox + bw - 1 ? C.od : C.o);
  const mx = ox + Math.floor(bw / 2), my = by + Math.floor(bhh / 2);
  if (bw >= 9 && bhh >= 3){ G.set(mx + 1, my - 1, C.cream); G.set(mx, my, C.cream); G.set(mx - 1, my + 1, C.cream); }
  else G.set(mx, my, C.cream);
  // Glanzlicht
  for (let y = oy + 3; y < oy + bh - 1; y++) if (y < by || y >= by + bhh) G.set(ox + 1, y, y % 3 === 0 ? '#4d7aa0' : C.L);
  G.outline(C.k); return G.canvas();
}
function nineSprite(){
  const G = grid(11, 15);
  G.rect(2, 1, 3, 2, C.gl); G.set(2, 1, C.g); G.rect(6, 1, 3, 2, C.g); G.set(7, 1, C.gl);
  for (let y = 3; y < 14; y++) for (let x = 1; x < 10; x++) G.set(x, y, x === 1 ? C.L : x === 9 ? C.nd : C.N);
  G.rect(1, 3, 9, 1, C.g); G.rect(1, 7, 9, 3, C.o); G.rect(1, 7, 1, 3, C.o2); G.rect(9, 7, 1, 3, C.od);
  G.set(6, 7, C.cream); G.set(5, 8, C.cream); G.set(4, 9, C.cream);
  G.rect(1, 13, 9, 1, C.gd);
  G.outline(C.k); return G.canvas();
}
const coinFrames = [1, 0.78, 0.45, 0.14, 0.45, 0.78].map(s => {
  const G = grid(11, 11), rx = Math.max(0.6, 4.5 * s), ry = 4.5;
  for (let y = 0; y < 11; y++) for (let x = 0; x < 11; x++){
    const dx = x - 5, dy = y - 5, q = (dx * dx) / (rx * rx) + (dy * dy) / (ry * ry);
    if (q <= 1.02){
      const rim = (dx * dx) / ((rx - 1.1) * (rx - 1.1) || 0.01) + (dy * dy) / ((ry - 1.1) * (ry - 1.1)) > 1;
      let c = dx < -rx * 0.35 ? '#e3edf5' : dx > rx * 0.35 ? '#6f879c' : '#a9bccd';
      if (s < 0.3) c = dy < -1 ? C.gl : C.g;
      else if (rim) c = dx < 0 ? '#c3d2df' : '#5d7489';
      G.set(x, y, c);
    }
  }
  if (s > 0.6){ ['#6f879c'].forEach(c => { G.set(5, 4, c); G.set(4, 5, c); G.set(5, 5, c); G.set(6, 5, c); G.set(5, 6, c); }); }
  G.outline(C.k); return G.canvas();
});
const SPR = {
  aaa: cylSprite(5, 12), aa: cylSprite(6, 15), c: cylSprite(9, 15), d: cylSprite(11, 19), v9: nineSprite()
};
function halo(col, r){ const [c, x] = mk(r * 2, r * 2); const g = x.createRadialGradient(r, r, 0, r, r, r); g.addColorStop(0, col); g.addColorStop(1, 'rgba(0,0,0,0)'); x.fillStyle = g; x.fillRect(0, 0, r * 2, r * 2); return c; }
const HALO = { o: halo('rgba(255,110,60,.42)', 13), big: halo('rgba(255,178,74,.55)', 18), e: halo('rgba(89,220,255,.45)', 15), r: halo('rgba(255,46,77,.45)', 15), w: halo('rgba(230,245,255,.35)', 14) };

/* ---------- Power-ups ---------- */
const PW = {
  charger: { name:'Schnellladegerät', short:'LADEGERÄT', col:C.amb, text:'Akku voll + Turbo', dur:3,
    icon:['....##..','...##...','..##....','.######.','....##..','...##...','..##....','.##.....'] },
  bank:    { name:'Powerbank', short:'POWERBANK', col:C.e, text:'8 s kein Verbrauch', dur:8,
    icon:['..g##g..','.######.','.#w..w#.','.#w..w#.','.#....#.','.#w..w#.','.######.','........'] },
  magnet:  { name:'Magnet', short:'MAGNET', col:C.r, text:'zieht Batterien an', dur:9,
    icon:['.gg..gg.','.##..##.','.##..##.','.##..##.','.##..##.','.######.','..####..','........'] },
  shield:  { name:'Extra-Life-Schild', short:'SCHILD', col:C.o, text:'hält einen Treffer ab', dur:0,
    icon:['...##...','.##ww##.','##w####.','##w#####','########','.######.','..####..','...##...'] }
};
function pwSprite(type){
  const p = PW[type], G = grid(16, 16);
  for (let y = 1; y < 15; y++) for (let x = 1; x < 15; x++){
    const corner = (x === 1 || x === 14) && (y === 1 || y === 14);
    if (corner) continue;
    const edge = x === 1 || x === 14 || y === 1 || y === 14;
    G.set(x, y, edge ? p.col : C.n0);
  }
  G.map(p.icon, 4, 4, { '#': p.col, g: C.gl, w: '#ffffff' });
  G.outline(C.k); return G.canvas();
}
const PWS = {}; Object.keys(PW).forEach(k => PWS[k] = pwSprite(k));
function pwIconSmall(type){ const p = PW[type], G = grid(8, 8); G.map(p.icon, 0, 0, { '#': p.col, g: C.gl, w: '#ffffff' }); return G.canvas(); }
const PWI = {}; Object.keys(PW).forEach(k => PWI[k] = pwIconSmall(k));

/* ---------- Gefahren ---------- */
const EMIT = (() => { const G = grid(11, 11); G.rect(1, 1, 9, 9, C.gd); G.rect(1, 1, 9, 2, C.o); G.rect(1, 1, 1, 9, C.g); G.rect(9, 3, 1, 7, '#33475a'); G.rect(3, 4, 5, 5, C.n0); G.rect(4, 5, 3, 3, C.e); G.set(5, 6, C.ew); G.outline(C.k); return G.canvas(); })();
const DRONE = (() => { const G = grid(17, 11); G.rect(2, 4, 13, 4, C.gd); G.rect(3, 4, 11, 1, C.g); G.rect(2, 7, 13, 1, '#33475a'); G.rect(6, 8, 5, 2, '#2b3a4a'); G.set(3, 3, C.g); G.set(13, 3, C.g); G.rect(3, 2, 1, 1, C.gl); G.rect(13, 2, 1, 1, C.gl); G.rect(6, 5, 5, 2, C.n0); G.outline(C.k); return G.canvas(); })();
const LEMIT = (() => { const G = grid(8, 13); G.rect(1, 1, 6, 11, C.gd); G.rect(1, 1, 1, 11, C.g); G.rect(1, 1, 6, 2, C.r); G.rect(3, 5, 3, 3, C.rd); G.set(4, 6, '#ffd0d8'); G.outline(C.k); return G.canvas(); })();

/* ---------- Hintergrund: Himmel, Mond (Knopfzelle), Batterie-Skyline ---------- */
function buildSky(){
  const [c, x] = mk(W, H), id = x.createImageData(W, H);
  const stops = [[0, [4, 9, 19]], [0.38, [8, 22, 40]], [0.66, [17, 36, 64]], [0.84, [44, 34, 60]], [1, [92, 44, 44]]];
  const bayer = [0, 8, 2, 10, 12, 4, 14, 6, 3, 11, 1, 9, 15, 7, 13, 5];
  for (let y = 0; y < H; y++){
    const t = y / H; let i = 0; while (i < stops.length - 2 && t > stops[i + 1][0]) i++;
    const a = stops[i], b = stops[i + 1], u = (t - a[0]) / (b[0] - a[0]);
    const col = [0, 1, 2].map(k => a[1][k] + (b[1][k] - a[1][k]) * u);
    for (let xx = 0; xx < W; xx++){
      const th = (bayer[(y & 3) * 4 + (xx & 3)] / 16 - 0.5) * 6;
      const p = (y * W + xx) * 4;
      for (let k = 0; k < 3; k++) id.data[p + k] = clamp(Math.round((col[k] + th) / 3) * 3, 0, 255);
      id.data[p + 3] = 255;
    }
  }
  x.putImageData(id, 0, 0);
  const r = rng(11);
  for (let i = 0; i < 90; i++){ const sx = r() * W, sy = r() * 120; x.fillStyle = `rgba(220,235,255,${0.15 + r() * 0.35})`; x.fillRect(sx | 0, sy | 0, 1, 1); }
  return c;
}
const STARS = Array.from({ length: 26 }, () => ({ x: R0() * W | 0, y: R0() * 110 | 0, p: R0() * 6.28, s: R0() < 0.25 ? 2 : 1 }));
function buildMoon(){
  const S = 44, [c, x] = mk(S, S); const id = x.createImageData(S, S), r = 17, cx = 22, cy = 22;
  for (let y = 0; y < S; y++) for (let xx = 0; xx < S; xx++){
    const dx = xx - cx + 0.5, dy = y - cy + 0.5, d = Math.hypot(dx, dy);
    if (d > r) continue;
    let v = 168 - dx * 2.2 - dy * 1.6;
    if (d > r - 1.6) v = dx + dy < 0 ? 226 : 104;
    else if (d > r - 3.2) v -= 26;
    if (Math.abs(d - 9) < 0.55) v -= 18;
    if ((Math.abs(dx) < 1.1 && Math.abs(dy) < 5) || (Math.abs(dy) < 1.1 && Math.abs(dx) < 5)) v -= 34;
    const p = (y * S + xx) * 4; v = clamp(Math.round(v / 8) * 8, 0, 255);
    id.data[p] = v * 0.86; id.data[p + 1] = v * 0.93; id.data[p + 2] = v; id.data[p + 3] = 255;
  }
  x.putImageData(id, 0, 0); return c;
}
const SKY = buildSky(), MOON = buildMoon(), MOONGLOW = halo('rgba(180,220,255,.20)', 40);

function blit(dst, src, x, y){ dst.drawImage(src, Math.round(x), Math.round(y)); }
function tileLayer(width, seed, makeBuilding, gapFn){
  const [c, x] = mk(width, H); const r = rng(seed); let px = 0;
  while (px < width){
    const b = makeBuilding(r); blit(x, b, px, 0);
    if (px + b.width > width) blit(x, b, px - width, 0);
    px += b.width + gapFn(r);
  }
  return c;
}
// Ferne Ebene: Hochhäuser in Batterieform (AA-Turm, 9V-Block, D-Mono, Knopfzellen-Stapel)
function farBuilding(r){
  const type = ['aa', 'aa', 'nine', 'd', 'coin', 'slab', 'plain'][Math.floor(r() * 7)];
  const base = GROUND - 8;
  const body = '#0c1d31', rimc = '#173250', dark = '#091727';
  let w = 22 + Math.floor(r() * 18), h = 70 + Math.floor(r() * 64);
  if (type === 'nine'){ w = 34 + Math.floor(r() * 12); h = 60 + Math.floor(r() * 40); }
  if (type === 'd'){ w = 38 + Math.floor(r() * 12); h = 56 + Math.floor(r() * 36); }
  if (type === 'coin'){ w = 36 + Math.floor(r() * 10); h = 0; }
  const [c, x] = mk(w + 4, H);
  const top = base - h;
  const windows = (x0, y0, ww, hh) => {
    for (let yy = y0 + 4; yy < y0 + hh - 3; yy += 4) for (let xx = x0 + 3; xx < x0 + ww - 3; xx += 3){
      const q = r(); if (q < 0.26){ x.fillStyle = q < 0.04 ? 'rgba(255,76,41,.55)' : q < 0.08 ? 'rgba(89,220,255,.35)' : `rgba(255,178,74,${0.18 + r() * 0.3})`; x.fillRect(xx, yy, 1, 2); }
    }
  };
  x.fillStyle = body;
  if (type === 'coin'){
    let y = base, n = 4 + Math.floor(r() * 4), cw = w;
    for (let i = 0; i < n; i++){
      const hh = 7; y -= hh;
      x.fillStyle = body; x.fillRect(1, y + 1, cw - 2, hh - 1); x.fillRect(0, y + 2, cw, hh - 3);
      x.fillStyle = rimc; x.fillRect(1, y + 1, cw - 2, 1);
      x.fillStyle = 'rgba(255,178,74,.35)'; for (let k = 4; k < cw - 4; k += 4) if (r() < 0.55) x.fillRect(k, y + 4, 2, 1);
      x.fillStyle = dark; x.fillRect(0, y + hh - 1, cw, 1);
    }
    x.fillStyle = 'rgba(255,76,41,.8)'; const mx = (cw / 2) | 0; x.fillRect(mx - 2, y - 3, 5, 1); x.fillRect(mx, y - 5, 1, 5);
    return c;
  }
  if (type === 'd'){ x.fillRect(2, top + 2, w - 4, h - 2); x.fillRect(0, top + 5, w, h - 5); x.fillRect(1, top + 3, w - 2, h - 3); }
  else x.fillRect(0, top, w, h);
  x.fillStyle = rimc; x.fillRect(0, top + 2, 1, h - 2);
  windows(0, top + 6, w, h - 6);
  if (type === 'aa' || type === 'd'){
    const cw = Math.max(6, (w / 3) | 0), cx = ((w - cw) / 2) | 0;
    x.fillStyle = body; x.fillRect(cx, top - 5, cw, 5); x.fillStyle = rimc; x.fillRect(cx, top - 5, cw, 1);
    x.fillStyle = 'rgba(255,76,41,.85)'; x.fillRect(cx + ((cw / 2) | 0), top - 11, 1, 6); x.fillStyle = C.r; x.fillRect(cx + ((cw / 2) | 0), top - 12, 1, 1);
    const by = top + ((h * 0.28) | 0);
    x.fillStyle = '#132b46'; x.fillRect(0, by, w, 7);
    x.fillStyle = 'rgba(255,76,41,.7)'; x.fillRect(0, by, w, 1); x.fillRect(0, by + 6, w, 1);
  }
  if (type === 'nine'){
    x.fillStyle = body; x.fillRect(4, top - 4, 9, 4); x.fillRect(w - 13, top - 4, 9, 4); x.fillRect(w - 12, top - 5, 7, 1);
    x.fillStyle = rimc; x.fillRect(4, top - 4, 9, 1); x.fillRect(w - 12, top - 5, 7, 1);
    x.fillStyle = 'rgba(255,76,41,.7)'; x.fillRect(0, top + 12, w, 1); x.fillRect(0, top + 20, w, 1);
  }
  if (type === 'slab'){
    for (let s = 0; s < 4; s++){ x.fillStyle = s < 1 + Math.floor(r() * 4) ? 'rgba(255,76,41,.55)' : 'rgba(255,255,255,.06)'; x.fillRect(w - 6, top + 8 + s * 7, 3, 5); }
  }
  if (type === 'plain'){ x.fillStyle = body; x.fillRect(4, top - 6, w - 10, 6); x.fillStyle = rimc; x.fillRect(4, top - 6, w - 10, 1); }
  return c;
}
// Mittlere Ebene: Häuserzeile mit Leuchtschriften, Fenstern, Ladestands-Fenstern
const SIGNS = ['AKKURANDO', 'MAH-BAR', 'LADESTATION', '24/7', 'KNOPFZELLEN', 'VOLT', 'NEO-AKKU', 'PFORZHEIM', 'POWER', 'CHARGE', 'ZELLE 9', 'AMPERE', 'LITHIUM', 'ALKALINE', 'OHM', 'RECYCLING', 'NUDELBAR', 'ARCADE', 'HOTEL ZINK', 'KILOWATT', 'PLUSPOL', 'NIMH'];
let lastSign = '';
const VSIGNS = ['AKKU', 'VOLT', 'MAH', 'LADEN', '24H', 'ZINK'];
function midBuilding(r){
  const w = 34 + Math.floor(r() * 46), h = 46 + Math.floor(r() * 58), base = GROUND;
  const [c, x] = mk(w + 14, H); const top = base - h;
  const body = r() < 0.5 ? '#10273f' : '#0e2238';
  x.fillStyle = body; x.fillRect(0, top, w, h);
  x.fillStyle = '#1a3a5c'; x.fillRect(0, top, w, 1); x.fillRect(0, top, 1, h);
  x.fillStyle = '#081627'; x.fillRect(w - 1, top, 1, h);
  // Dachaufbauten
  if (r() < 0.6){ const aw = 8 + Math.floor(r() * 8), ax = 3 + Math.floor(r() * (w - aw - 6)); x.fillStyle = '#18324f'; x.fillRect(ax, top - 5, aw, 5); x.fillStyle = '#25476b'; x.fillRect(ax, top - 5, aw, 1); x.fillStyle = '#081627'; for (let k = 1; k < aw - 1; k += 2) x.fillRect(ax + k, top - 3, 1, 2); }
  if (r() < 0.5){ const ax = 2 + Math.floor(r() * (w - 4)); x.fillStyle = '#25476b'; x.fillRect(ax, top - 12, 1, 12); x.fillStyle = C.r; x.fillRect(ax, top - 13, 1, 1); }
  if (r() < 0.35){ x.fillStyle = '#25476b'; const dx = 4 + Math.floor(r() * (w - 12)); x.fillRect(dx, top - 7, 6, 2); x.fillRect(dx + 1, top - 9, 4, 2); x.fillRect(dx + 3, top - 5, 1, 5); }
  // Fenster
  const ww = 3, wh = 3, gx = 2, gy = 3;
  for (let yy = top + 6; yy < base - 14; yy += wh + gy) for (let xx = 3; xx < w - 4; xx += ww + gx){
    const q = r();
    if (q < 0.42){ x.fillStyle = q < 0.06 ? 'rgba(255,76,41,.75)' : q < 0.11 ? 'rgba(89,220,255,.45)' : q < 0.22 ? 'rgba(255,227,196,.55)' : `rgba(255,178,74,${0.35 + r() * 0.35})`; x.fillRect(xx, yy, ww, wh); }
    else { x.fillStyle = '#0a1a2c'; x.fillRect(xx, yy, ww, wh); }
  }
  // Ladestands-Fenster (wie eine Akkuanzeige)
  if (r() < 0.35 && h > 60){
    const lx = w - 8, n = 4, lit = 1 + Math.floor(r() * 4);
    x.fillStyle = '#071526'; x.fillRect(lx - 1, top + 8, 6, n * 6 + 2); x.fillRect(lx + 1, top + 6, 2, 2);
    for (let s = 0; s < n; s++){ x.fillStyle = (n - s) <= lit ? (lit === 1 ? C.r : C.o) : '#14304d'; x.fillRect(lx, top + 9 + s * 6, 4, 5); }
  }
  // Leuchtschrift
  const q = r();
  if (q < 0.6){
    const fits = SIGNS.filter(s => s.length * 6 + 7 <= w - 4);
    if (fits.length){
      let s = fits[Math.floor(r() * fits.length)]; if (s === lastSign && fits.length > 1) s = fits[(fits.indexOf(s) + 1) % fits.length]; lastSign = s; const tw = s.length * 6 - 1;
      const sx = Math.floor((w - tw) / 2), sy = top + 8 + Math.floor(r() * Math.max(1, Math.min(18, h - 40)));
      const col = r() < 0.62 ? C.o : r() < 0.6 ? C.amb : r() < 0.5 ? C.e : C.w;
      x.fillStyle = '#050e1a'; x.fillRect(sx - 4, sy - 3, tw + 8, 13);
      x.strokeStyle = col; x.globalAlpha = 0.55; x.strokeRect(sx - 3.5, sy - 2.5, tw + 7, 12); x.globalAlpha = 1;
      x.drawImage(tex(s, col, 1, col), sx - 5, sy - 5);
    }
  } else if (q < 0.8){
    const s = VSIGNS[Math.floor(r() * VSIGNS.length)], hh = s.length * 9 + 4;
    if (hh < h - 14){
      const sx = w + 2, sy = top + 6, col = r() < 0.6 ? C.o : C.e;
      x.fillStyle = '#050e1a'; x.fillRect(sx - 1, sy - 1, 9, hh); x.fillStyle = '#25476b'; x.fillRect(sx - 3, sy + 2, 2, 1); x.fillRect(sx - 3, sy + hh - 5, 2, 1);
      for (let i = 0; i < s.length; i++) x.drawImage(tex(s[i], col, 1, col), sx - 4, sy + 1 + i * 9 - 5);
    }
  }
  // Ladenzeile unten
  if (r() < 0.75){
    const sh = 10, sy = base - sh; x.fillStyle = '#071322'; x.fillRect(2, sy, w - 4, sh);
    const glow = r() < 0.5 ? 'rgba(255,178,74,.55)' : r() < 0.5 ? 'rgba(255,76,41,.5)' : 'rgba(89,220,255,.45)';
    x.fillStyle = glow; x.fillRect(4, sy + 3, w - 8, sh - 3);
    x.fillStyle = '#071322'; for (let k = 8; k < w - 6; k += 9) x.fillRect(k, sy + 3, 1, sh - 3);
    x.fillStyle = r() < 0.5 ? C.o : '#1f3d5c'; for (let k = 2; k < w - 2; k += 4){ x.fillRect(k, sy - 2, 2, 3); }
  }
  return c;
}
const FAR = tileLayer(896, 23, farBuilding, r => 2 + Math.floor(r() * 10));
const MID = tileLayer(1024, 57, midBuilding, r => 6 + Math.floor(r() * 14));
function buildStreet(){
  const SW = 256, [c, x] = mk(SW, H);
  x.fillStyle = '#1b3654'; x.fillRect(0, GROUND, SW, 2); x.fillStyle = '#28507a'; x.fillRect(0, GROUND, SW, 1);
  x.fillStyle = '#0d1f33'; x.fillRect(0, GROUND + 2, SW, 3);
  x.fillStyle = '#16304b'; for (let k = 0; k < SW; k += 16) x.fillRect(k, GROUND + 2, 1, 3);
  x.fillStyle = '#081523'; x.fillRect(0, GROUND + 5, SW, H - GROUND - 5);
  for (let k = 0; k < SW; k += 32){ x.fillStyle = 'rgba(255,76,41,.85)'; x.fillRect(k + 6, GROUND + 12, 14, 1); x.fillStyle = 'rgba(255,76,41,.18)'; x.fillRect(k + 5, GROUND + 11, 16, 3); }
  const r = rng(91);
  for (let i = 0; i < 40; i++){ x.fillStyle = r() < 0.5 ? 'rgba(255,178,74,.10)' : 'rgba(89,220,255,.08)'; x.fillRect(r() * SW | 0, GROUND + 6 + (r() * 14 | 0), 2 + (r() * 6 | 0), 1); }
  x.fillStyle = '#0f243a'; x.fillRect(150, GROUND + 15, 8, 2); x.fillStyle = '#16304b'; x.fillRect(151, GROUND + 15, 6, 1);
  return c;
}
const STREET = buildStreet();
function buildLamps(){
  const SW = 256, [c, x] = mk(SW, H), lx = 96;
  const g = x.createLinearGradient(0, 154, 0, GROUND);
  g.addColorStop(0, 'rgba(255,178,74,.22)'); g.addColorStop(1, 'rgba(255,178,74,.02)');
  x.fillStyle = g; x.beginPath(); x.moveTo(lx + 6, 154); x.lineTo(lx + 9, 154); x.lineTo(lx + 28, GROUND); x.lineTo(lx - 12, GROUND); x.closePath(); x.fill();
  x.fillStyle = '#16304b'; x.fillRect(lx, 150, 2, GROUND - 150); x.fillRect(lx, 150, 10, 2);
  x.fillStyle = '#25476b'; x.fillRect(lx, 150, 1, GROUND - 150);
  x.fillStyle = C.amb; x.fillRect(lx + 5, 152, 6, 2); x.fillStyle = C.cream; x.fillRect(lx + 6, 153, 4, 1);
  x.fillStyle = 'rgba(255,178,74,.25)'; x.fillRect(lx - 14, GROUND + 6, 40, 2);
  return c;
}
const LAMPS = buildLamps();
function buildBlimp(){
  const G = grid(78, 24);
  for (let y = 4; y < 19; y++){ const inset = y < 6 || y > 16 ? (y === 4 || y === 18 ? 4 : 2) : 0; for (let x = 8 + inset; x < 70 - inset; x++) G.set(x, y, y < 8 ? C.L : y > 15 ? C.nd : C.N); }
  G.rect(4, 8, 4, 7, C.g); G.rect(4, 8, 4, 1, C.gl); G.rect(2, 10, 2, 3, C.gl);
  G.rect(12, 4, 3, 15, C.o); G.rect(12, 4, 1, 15, C.o2);
  G.rect(70, 6, 5, 3, C.o); G.rect(70, 14, 5, 3, C.o); G.rect(68, 9, 3, 5, C.od);
  G.rect(34, 19, 14, 3, C.gd); G.rect(36, 20, 2, 1, C.amb); G.rect(40, 20, 2, 1, C.amb); G.rect(44, 20, 2, 1, C.amb);
  G.rect(18, 8, 46, 7, '#050e1a');
  G.outline(C.k); return G.canvas();
}
const BLIMP = buildBlimp();
const BLIMP_TXT = tex('  AKKURANDO · CHARGE & RUN · 100% ENERGIE · ', C.o, 1, null);


/* ---------- Akkurando-Logo (aus der Vektordatei des Blisters) als Pixelgrafik ---------- */
const LOGO_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.10 18.40"><path fill="#d1d1d1" d="M2.86 4.92 L11.83 4.92 L12.71 3.06 L2.86 3.06 C1.29 3.06 0.03 4.32 0.03 5.89 L0.03 13.54 C0.03 15.10 1.29 16.37 2.86 16.37 L11.71 16.37 L11.71 14.51 L2.86 14.51 C2.32 14.51 1.89 14.07 1.89 13.54 L1.89 5.89 C1.89 5.35 2.32 4.92 2.86 4.92 M13.22 16.37 L14.18 16.37 L15.07 14.51 L13.22 14.51 L13.22 16.37 M26.23 3.06 L17.37 3.06 L17.37 4.92 L26.23 4.92 C26.77 4.92 27.20 5.35 27.20 5.89 L27.20 13.54 C27.20 14.07 26.77 14.51 26.23 14.51 L16.74 14.51 L15.85 16.37 L26.23 16.37 C27.79 16.37 29.05 15.10 29.05 13.54 L29.05 5.89 C29.05 4.32 27.79 3.06 26.23 3.06 M14.39 3.06 L13.49 4.92 L15.87 4.92 L15.87 3.06 L14.39 3.06 L13.49 4.92 L15.87 4.92 L15.87 3.06 L14.39 3.06Z"/><path fill="#ff4c29" d="M18.52 7.37 L15.07 14.51 L14.18 16.37 L13.22 18.37 L13.22 10.99 L10.57 10.99 L13.49 4.92 L14.39 3.06 L15.87 -0.01 L15.87 7.37 L18.52 7.37Z"/></svg>';
const LOGO = {};
function pixelLogo(h, key){
  const img = new Image();
  img.onload = () => {
    const w = Math.round(h * 29.1 / 18.4), SS = 8, [b, bx] = mk(w * SS, h * SS);
    bx.imageSmoothingEnabled = true; bx.drawImage(img, 0, 0, w * SS, h * SS);
    const big = bx.getImageData(0, 0, w * SS, h * SS).data, [c, x] = mk(w, h), id = x.createImageData(w, h), d = id.data;
    // je Zielpixel: Deckung und Farbe aus 8×8 Teilpixeln → klare Kanten ohne Matsch
    for (let py = 0; py < h; py++) for (let px = 0; px < w; px++){
      let cov = 0, or = 0;
      for (let sy = 0; sy < SS; sy++) for (let sx = 0; sx < SS; sx++){ const k = ((py * SS + sy) * w * SS + (px * SS + sx)) * 4; if (big[k + 3] > 127){ cov++; if (big[k] > 180 && big[k + 1] < 160) or++; } }
      const o = (py * w + px) * 4; if (cov < SS * SS * 0.42) continue;
      const orange = or > cov / 2; d[o] = orange ? 255 : 209; d[o + 1] = orange ? 76 : 209; d[o + 2] = orange ? 41 : 209; d[o + 3] = 255;
    }
    x.putImageData(id, 0, 0); LOGO[key] = c;
  };
  img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(LOGO_SVG);
}
pixelLogo(19, 'title'); pixelLogo(14, 'hud');
/* ---------- Spielzustand ---------- */
const S = {
  state: 'title', t: 0, scroll: 0, dist: 0, mah: 0, bonus: 0, energy: 100, speed: 100,
  p: { x: 62, y: 96, vy: 0, ground: false, face: 'smile', faceT: 0, inv: 0, shield: false, turbo: 0, bank: 0, magnet: 0, run: 0 },
  thrust: false, items: [], haz: [], lasers: [], parts: [], pops: [], rain: [], cars: [], blimp: null,
  nextAt: 0, pwCool: 0, combo: 0, lastPick: -9, shake: 0, flash: 0, dieT: 0, cause: '', best: 0, lowBeep: 0,
  blimpT: 6
};
try { S.best = +localStorage.getItem('akkunaut-best') || 0; } catch (e) {}
for (let i = 0; i < (RM ? 0 : 70); i++) S.rain.push({ x: R0() * W, y: R0() * H, l: 3 + R0() * 3 });
for (let i = 0; i < 5; i++) S.cars.push(newCar(R0() * W));
function newCar(x){ return { x: x ?? W + rnd(10, 200), y: rnd(56, 120) | 0, v: rnd(-40, 30), dir: R0() < 0.5 ? 1 : -1 }; }

const meters = () => Math.floor(S.dist / 10);
const score = () => meters() + Math.floor(S.mah / 100) + S.bonus;

/* ---------- Ton (wird im Browser erzeugt, standardmäßig aus) ---------- */
const AU = { on: false, ac: null };
function ac(){ if (!AU.ac){ const A = window.AudioContext || window.webkitAudioContext; if (!A) return null; AU.ac = new A(); } if (AU.ac.state === 'suspended') AU.ac.resume(); return AU.ac; }
function tone(freq, dur, type = 'square', vol = 0.05, slide = 0, delay = 0){
  if (!AU.on) return; const a = ac(); if (!a) return; const t = a.currentTime + delay;
  const o = a.createOscillator(), g = a.createGain(); o.type = type; o.frequency.setValueAtTime(freq, t);
  if (slide) o.frequency.exponentialRampToValueAtTime(Math.max(30, freq + slide), t + dur);
  g.gain.setValueAtTime(vol, t); g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.connect(g).connect(a.destination); o.start(t); o.stop(t + dur + 0.03);
}
function noise(dur, vol = 0.05, freq = 1400){
  if (!AU.on) return; const a = ac(); if (!a) return;
  const b = a.createBuffer(1, Math.floor(a.sampleRate * dur), a.sampleRate), d = b.getChannelData(0);
  for (let i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / d.length);
  const s = a.createBufferSource(), f = a.createBiquadFilter(), g = a.createGain();
  f.type = 'bandpass'; f.frequency.value = freq; g.gain.value = vol; s.buffer = b; s.connect(f).connect(g).connect(a.destination); s.start();
}
const SFX = {
  pick(k){ const base = { cr2032: 1568, aaa: 1318, aa: 1046, v9: 880, c: 784, d: 659 }[k] || 1200;
    tone(base, 0.07, 'square', 0.04); tone(base * 1.5, 0.09, 'square', 0.035, 0, 0.05);
    if (k === 'c' || k === 'd'){ tone(base * 2, 0.14, 'triangle', 0.05, 0, 0.11); } },
  power(){ [523, 659, 784, 1046, 1318].forEach((f, i) => tone(f, 0.09, 'square', 0.04, 0, i * 0.055)); },
  zap(){ noise(0.35, 0.09, 1800); tone(220, 0.4, 'sawtooth', 0.05, -160); },
  shield(){ noise(0.2, 0.07, 900); tone(660, 0.15, 'triangle', 0.05, -300); },
  empty(){ [440, 370, 311, 247].forEach((f, i) => tone(f, 0.16, 'square', 0.045, -20, i * 0.13)); },
  low(){ tone(988, 0.06, 'square', 0.025); },
  start(){ tone(392, 0.08, 'square', 0.04); tone(587, 0.12, 'square', 0.04, 0, 0.08); },
  thrust(){ noise(0.06, 0.012, 500); }
};

/* ---------- Spawner ---------- */
function laneY(){ return rnd(24, GROUND - 34); }
function addItem(kind, x, y){ S.items.push({ kind, x, y, ph: R0() * 6.28, t: 0 }); }
function spawnTrail(){
  const n = 5 + Math.floor(R0() * 5), shape = pick(['line', 'sine', 'arc', 'steps', 'sine']);
  const y0 = rnd(34, GROUND - 40), sp = 13, amp = rnd(10, 22);
  for (let i = 0; i < n; i++){
    let y = y0;
    if (shape === 'sine') y = y0 + Math.sin(i / n * Math.PI * 2) * amp;
    if (shape === 'arc') y = y0 - Math.sin(i / (n - 1) * Math.PI) * amp * 1.4;
    if (shape === 'steps') y = y0 + (Math.floor(i / 3) % 2 ? -12 : 0);
    const kind = R0() < 0.72 ? 'cr2032' : 'aaa';
    addItem(i === n - 1 && R0() < 0.35 ? 'aa' : kind, W + 16 + i * sp, clamp(y, 18, GROUND - 22));
  }
  return n * sp;
}
function bigKind(){ const q = R0(); return q < 0.46 ? 'aa' : q < 0.7 ? 'v9' : q < 0.9 ? 'c' : 'd'; }
function spawnZap(x, y, ang, len){
  len = len ?? rnd(36, 70);
  if (ang == null) ang = pick([Math.PI / 2, Math.PI / 2, 0, Math.PI / 4, -Math.PI / 4]);
  const hy = Math.abs(Math.sin(ang)) * len / 2 + 6;
  y = clamp(y ?? laneY(), 14 + hy, GROUND - 6 - hy);
  const rot = meters() > 900 && R0() < 0.3 ? rnd(-1.1, 1.1) : 0;
  S.haz.push({ kind: 'zap', x: x ?? W + 30, y, ang, len, rot, ph: R0() * 9 });
  return Math.abs(Math.cos(ang)) * len + 20;
}
function spawn(){
  const m = meters(), diff = Math.min(1, S.dist / 30000);
  const W8 = [
    ['trail', 38], ['big', m > 40 ? 14 : 0], ['zap', m > 60 ? 20 + 10 * diff : 0], ['drone', m > 260 ? 9 + 6 * diff : 0],
    ['laser', m > 420 ? 6 + 6 * diff : 0], ['puddle', m > 160 ? 7 : 0], ['power', m > 220 && S.pwCool <= 0 ? 8 : 0],
    ['gate', m > 520 ? 7 + 6 * diff : 0], ['risk', m > 320 ? 6 : 0]
  ];
  let tot = W8.reduce((a, b) => a + b[1], 0), q = R0() * tot, kind = 'trail';
  for (const [k, w] of W8){ if ((q -= w) < 0){ kind = k; break; } }
  let len = 0;
  if (kind === 'trail') len = spawnTrail();
  else if (kind === 'big'){ addItem(bigKind(), W + 16, laneY()); len = 20; }
  else if (kind === 'zap') len = spawnZap();
  else if (kind === 'drone'){ const n = m > 900 && R0() < 0.4 ? 2 : 1; for (let i = 0; i < n; i++) S.haz.push({ kind: 'drone', x: W + 20 + i * 46, y0: laneY(), y: 0, ph: R0() * 6, amp: rnd(10, 22) }); len = n * 46; }
  else if (kind === 'laser'){ const n = m > 1200 && R0() < 0.35 ? 2 : 1; const ys = n === 2 ? [rnd(48, 96), rnd(122, GROUND - 16)] : [rnd(48, GROUND - 16)]; ys.forEach(y => S.lasers.push({ y: y | 0, t: 0, warn: 1.35, fire: 0.75 })); len = 60; }
  else if (kind === 'puddle'){ S.haz.push({ kind: 'puddle', x: W + 10, w: 34 + (R0() * 14 | 0), ph: 0 }); for (let i = 0; i < 4; i++) addItem('cr2032', W + 14 + i * 12, GROUND - 40 - Math.sin(i / 3 * Math.PI) * 14); len = 64; }
  else if (kind === 'power'){ S.items.push({ kind: 'pw', type: pick(['charger', 'bank', 'magnet', 'shield']), x: W + 20, y: laneY(), ph: 0, t: 0 }); S.pwCool = 520; len = 30; }
  else if (kind === 'gate'){ const gy = rnd(60, GROUND - 60), gap = rnd(44, 58); spawnZap(W + 30, gy - gap / 2 - 22, Math.PI / 2, 40); spawnZap(W + 30, gy + gap / 2 + 22, Math.PI / 2, 40); addItem(R0() < 0.5 ? 'c' : 'aa', W + 24, gy - 6); len = 50; }
  else if (kind === 'risk'){ const y = laneY(); addItem(R0() < 0.4 ? 'd' : 'c', W + 40, y); spawnZap(W + 40, clamp(y + pick([-30, 30]), 40, GROUND - 40), 0, 46); len = 70; }
  const gap = 150 - 50 * diff + R0() * 70;
  S.nextAt = S.dist + len + gap;
}

/* ---------- Partikel & Hinweise ---------- */
function burst(x, y, n, cols, sp = 60, life = 0.5, up = 0){
  if (RM) n = Math.ceil(n / 3);
  for (let i = 0; i < n; i++){ const a = R0() * Math.PI * 2, v = rnd(sp * 0.3, sp); S.parts.push({ x, y, vx: Math.cos(a) * v, vy: Math.sin(a) * v - up, life, max: life, c: pick(cols), s: R0() < 0.3 ? 2 : 1 }); }
}
function pop(text, x, y, col, sc = 1){ S.pops.push({ text, x, y, t: 0, col, sc }); }

/* ---------- Ablauf ---------- */
function reset(){
  Object.assign(S, { dist: 0, mah: 0, bonus: 0, energy: 100, speed: 105, items: [], haz: [], lasers: [], parts: [], pops: [], nextAt: 260, pwCool: 300, combo: 0, lastPick: -9, shake: 0, flash: 0, dieT: 0, cause: '', t: 0 });
  Object.assign(S.p, { y: 96, vy: 0, ground: false, face: 'smile', faceT: 0, inv: 0, shield: false, turbo: 0, bank: 0, magnet: 0, run: 0 });
}
function start(){ hideOver(); reset(); S.state = 'play'; SFX.start(); cv.focus({ preventScroll: true }); }
function die(cause){
  if (S.state !== 'play') return;
  S.state = 'dying'; S.cause = cause; S.dieT = 0; S.thrust = false;
  S.p.face = cause === 'empty' ? 'sad' : 'hit'; S.p.faceT = 99;
  if (cause === 'empty'){ SFX.empty(); pop('AKKU LEER', W / 2, 80, C.amb, 2); }
  else { SFX.zap(); S.shake = 0.5; S.flash = 0.6; burst(S.p.x + 15, S.p.y + 14, 40, [C.e, C.ew, C.w, C.o], 110, 0.7); pop('KURZSCHLUSS!', W / 2, 80, C.r, 2); }
  S.p.vy = cause === 'empty' ? 20 : -120;
}
function hit(){
  const p = S.p;
  if (p.inv > 0 || p.turbo > 0) return;
  if (p.shield){ p.shield = false; p.inv = 1.3; S.shake = 0.3; SFX.shield(); burst(p.x + 15, p.y + 14, 24, [C.o, C.o2, C.amb], 90, 0.5); pop('SCHILD WEG!', p.x + 16, p.y - 6, C.o); return; }
  die('zap');
}
function collect(it){
  const p = S.p;
  if (it.kind === 'pw'){
    const P = PW[it.type]; SFX.power();
    if (it.type === 'charger'){ S.energy = 100; p.turbo = P.dur; p.face = 'wow'; p.faceT = 1.2; }
    if (it.type === 'bank') p.bank = P.dur;
    if (it.type === 'magnet') p.magnet = P.dur;
    if (it.type === 'shield') p.shield = true;
    burst(it.x, it.y, 22, [P.col, C.w], 80, 0.55); S.ring = { x: it.x, y: it.y, t: 0, c: P.col };
    pop(P.short + '!', it.x, it.y - 10, P.col);
    return;
  }
  const b = BAT[it.kind];
  const before = S.energy; S.energy = Math.min(100, S.energy + b.pct);
  S.mah += b.mah;
  S.combo = (S.t - S.lastPick < 0.75) ? S.combo + 1 : 1; S.lastPick = S.t;
  if (S.combo >= 3) S.bonus += S.combo;
  if (b.boost){ p.turbo = Math.max(p.turbo, b.boost); }
  if (it.kind === 'c' || it.kind === 'd'){ p.face = 'happy'; p.faceT = 1; S.ring = { x: it.x, y: it.y, t: 0, c: C.amb }; }
  SFX.pick(it.kind);
  burst(it.x, it.y, it.kind === 'cr2032' ? 6 : 12, [C.amb, C.cream, C.o], 50, 0.4, 20);
  pop('+' + fmt(b.mah) + ' MAH', it.x, it.y - 12, it.kind === 'd' || it.kind === 'c' ? C.amb : C.cream);
  if (before < 100 && S.energy >= 100) pop('VOLL GELADEN', p.x + 16, p.y - 16, C.amb);
}

/* ---------- Update ---------- */
const PLR = () => ({ x: S.p.x + 9, y: S.p.y + 3, w: 13, h: 21 });
function rectHit(a, b){ return a.x < b.x + b.w && a.x + a.w > b.x && a.y < b.y + b.h && a.y + a.h > b.y; }
function segHit(r, x1, y1, x2, y2, pad){
  const n = Math.max(2, Math.ceil(Math.hypot(x2 - x1, y2 - y1) / 2));
  for (let i = 0; i <= n; i++){ const x = x1 + (x2 - x1) * i / n, y = y1 + (y2 - y1) * i / n;
    if (x > r.x - pad && x < r.x + r.w + pad && y > r.y - pad && y < r.y + r.h + pad) return true; }
  return false;
}
function zapEnds(h){ const dx = Math.cos(h.ang) * h.len / 2, dy = Math.sin(h.ang) * h.len / 2; return [h.x - dx, h.y - dy, h.x + dx, h.y + dy]; }

let thrustTick = 0;
function update(dt){
  S.t += dt;
  const p = S.p;
  // Umgebung läuft immer
  const bgSpeed = S.state === 'play' ? S.speed : S.state === 'dying' ? S.speed : S.state === 'title' ? 46 : 0;
  if (S.state !== 'pause' && S.state !== 'over') S.scroll += bgSpeed * dt;
  if (S.state !== 'pause'){
    for (const d of S.rain){ d.y += 230 * dt; d.x -= (bgSpeed * 0.5 + 40) * dt; if (d.y > H){ d.y = -6; d.x = R0() * (W + 60); } if (d.x < -6) d.x += W + 12; }
    for (const c of S.cars){ c.x += (c.dir * (24 + c.v) - bgSpeed * 0.18) * dt; if (c.x < -20 || c.x > W + 220) Object.assign(c, newCar(c.dir < 0 ? W + 10 : -10)); }
    S.blimpT -= dt;
    if (!S.blimp && S.blimpT <= 0){ S.blimp = { x: W + 10, y: rnd(40, 66) | 0, tx: 0 }; }
    if (S.blimp){ S.blimp.x -= (14 + bgSpeed * 0.16) * dt; S.blimp.tx += 18 * dt; if (S.blimp.x < -90){ S.blimp = null; S.blimpT = rnd(18, 34); } }
  }
  if (S.state === 'title'){
    p.y = 92 + Math.sin(S.t * 2) * 6; p.ground = false; p.face = 'smile';
    if (!RM && R0() < 0.5) flame(p, 0.6);
    stepFx(dt); return;
  }
  if (S.state === 'pause' || S.state === 'over'){ return; }
  if (S.state === 'dying'){
    S.dieT += dt; S.speed = Math.max(0, S.speed - S.speed * 2.2 * dt);
    p.vy += 420 * dt; p.y += p.vy * dt;
    if (p.y > GROUND - AK_H){ p.y = GROUND - AK_H; p.vy = 0; }
    if (S.cause !== 'empty' && R0() < 0.4) burst(p.x + 8, p.y + 20, 1, [C.e, C.ew], 30, 0.3);
    stepFx(dt); moveWorld(dt);
    if (S.dieT > 1.45) gameOver();
    return;
  }
  // --- Spiel läuft ---
  const diff = Math.min(1, S.dist / 30000);
  S.speed = (105 + 120 * diff) * (p.turbo > 0 ? 1.7 : 1);
  S.dist += S.speed * dt;
  const thrusting = S.thrust && S.energy > 0;
  const drain = p.bank > 0 ? 0 : (2.2 + 1.6 * diff + (thrusting ? 2.6 : 0));
  S.energy -= drain * dt;
  if (S.energy <= 0){ S.energy = 0; die('empty'); return; }
  // Physik
  if (thrusting){ p.vy -= 560 * dt; flame(p, 1); thrustTick -= dt; if (thrustTick <= 0){ SFX.thrust(); thrustTick = 0.09; } }
  else p.vy += 440 * dt;
  p.vy = clamp(p.vy, -165, 215); p.y += p.vy * dt;
  if (p.y < 10){ p.y = 10; if (p.vy < 0) p.vy = 0; }
  p.ground = false;
  if (p.y >= GROUND - AK_H){ p.y = GROUND - AK_H; if (p.vy > 0) p.vy = 0; p.ground = true; p.run += dt * (S.speed / 60); }
  // Timer
  p.inv = Math.max(0, p.inv - dt); p.turbo = Math.max(0, p.turbo - dt); p.bank = Math.max(0, p.bank - dt); p.magnet = Math.max(0, p.magnet - dt);
  S.pwCool -= S.speed * dt / 10;
  if (p.faceT > 0) p.faceT -= dt;
  else p.face = S.energy < 20 ? 'worry' : p.turbo > 0 ? 'wow' : 'smile';
  if (S.energy < 20){ S.lowBeep -= dt; if (S.lowBeep <= 0){ SFX.low(); S.lowBeep = 0.9; } }
  if (p.turbo > 0 && !RM && R0() < 0.8) S.parts.push({ x: p.x + rnd(0, 20), y: p.y + rnd(2, 26), vx: -260, vy: 0, life: 0.18, max: 0.18, c: C.amb, s: 1, streak: 1 });
  if (S.dist >= S.nextAt) spawn();
  moveWorld(dt);
  // Kollisionen
  const pr = PLR(), cxp = pr.x + pr.w / 2, cyp = pr.y + pr.h / 2;
  for (let i = S.items.length - 1; i >= 0; i--){
    const it = S.items[i];
    if (p.magnet > 0 && it.kind !== 'pw'){ const dx = cxp - it.x, dy = cyp - it.y, d = Math.hypot(dx, dy); if (d < 92){ it.x += dx / d * 300 * dt; it.y += dy / d * 300 * dt; it.mag = 1; } }
    const sz = it.kind === 'pw' ? 14 : (BAT[it.kind].w + 2);
    if (rectHit(pr, { x: it.x - sz / 2, y: it.y - sz / 2, w: sz, h: sz })){ collect(it); S.items.splice(i, 1); }
  }
  for (const h of S.haz){
    if (h.kind === 'zap'){ const [x1, y1, x2, y2] = zapEnds(h); if (segHit(pr, x1, y1, x2, y2, 1.5)) hit(); }
    else if (h.kind === 'drone'){ if (rectHit(pr, { x: h.x + 2, y: h.y + 2, w: 13, h: 7 })) hit(); }
    else if (h.kind === 'puddle'){ if (p.ground && pr.x + pr.w > h.x + 4 && pr.x < h.x + h.w - 4) hit(); }
  }
  for (const l of S.lasers){ if (l.t > l.warn && l.t < l.warn + l.fire && pr.y < l.y + 2 && pr.y + pr.h > l.y - 1) hit(); }
  stepFx(dt);
}
function moveWorld(dt){
  const sp = S.speed;
  for (let i = S.items.length - 1; i >= 0; i--){ const it = S.items[i]; it.x -= sp * dt; it.t += dt; if (it.x < -24) S.items.splice(i, 1); }
  for (let i = S.haz.length - 1; i >= 0; i--){
    const h = S.haz[i];
    if (h.kind === 'drone'){ h.x -= (sp + 28) * dt; h.ph += dt; h.y = h.y0 + Math.sin(h.ph * 2.3) * h.amp; }
    else { h.x -= sp * dt; h.ph += dt; if (h.kind === 'zap' && h.rot) h.ang += h.rot * dt; }
    if (h.x < -80) S.haz.splice(i, 1);
  }
  for (let i = S.lasers.length - 1; i >= 0; i--){ const l = S.lasers[i]; l.t += dt; if (l.t > l.warn + l.fire){ S.lasers.splice(i, 1); } else if (l.t > l.warn && l.t - dt <= l.warn){ S.shake = Math.max(S.shake, 0.12); noise(0.3, 0.05, 2600); } }
}
function flame(p, k){
  const nx = p.x + 7, ny = p.y + 23;
  const n = RM ? 1 : 2;
  for (let i = 0; i < n; i++) S.parts.push({ x: nx + rnd(-1, 1), y: ny + rnd(0, 2), vx: rnd(-70, -30), vy: rnd(70, 130) * k, life: rnd(0.16, 0.3), max: 0.3, c: 'fire', s: R0() < 0.4 ? 2 : 1 });
}
function stepFx(dt){
  for (let i = S.parts.length - 1; i >= 0; i--){ const q = S.parts[i]; q.x += q.vx * dt; q.y += q.vy * dt; q.vy += 60 * dt; q.life -= dt; if (q.life <= 0) S.parts.splice(i, 1); }
  for (let i = S.pops.length - 1; i >= 0; i--){ const q = S.pops[i]; q.t += dt; q.y -= 18 * dt; if (q.t > 1.1) S.pops.splice(i, 1); }
  S.shake = Math.max(0, S.shake - dt); S.flash = Math.max(0, S.flash - dt * 2.2);
  if (S.ring){ S.ring.t += dt; if (S.ring.t > 0.45) S.ring = null; }
}

/* ---------- Zeichnen ---------- */
function layer(c, off, y = 0){ const w = c.width; const x = -Math.floor(((off % w) + w) % w); ctx.drawImage(c, x, y); ctx.drawImage(c, x + w, y); if (x + 2 * w < W) ctx.drawImage(c, x + 2 * w, y); }
function pline(x0, y0, x1, y1, col, th = 1){
  x0 = Math.round(x0); y0 = Math.round(y0); x1 = Math.round(x1); y1 = Math.round(y1);
  const dx = Math.abs(x1 - x0), sx = x0 < x1 ? 1 : -1, dy = -Math.abs(y1 - y0), sy = y0 < y1 ? 1 : -1; let err = dx + dy;
  ctx.fillStyle = col; const o = (th - 1) / 2;
  for (;;){ ctx.fillRect(x0 - o, y0 - o, th, th); if (x0 === x1 && y0 === y1) break; const e2 = 2 * err; if (e2 >= dy){ err += dy; x0 += sx; } if (e2 <= dx){ err += dx; y0 += sy; } }
}
function drawArc(x1, y1, x2, y2, t){
  const n = Math.max(4, Math.round(Math.hypot(x2 - x1, y2 - y1) / 5)), nx = -(y2 - y1), ny = x2 - x1, nl = Math.hypot(nx, ny) || 1;
  const pts = [];
  for (let i = 0; i <= n; i++){ const u = i / n, j = (i === 0 || i === n) ? 0 : (Math.sin(t * 40 + i * 2.1) + (R0() - 0.5) * 1.6) * 2.2; pts.push([x1 + (x2 - x1) * u + nx / nl * j, y1 + (y2 - y1) * u + ny / nl * j]); }
  ctx.globalAlpha = 0.28; for (let i = 0; i < n; i++) pline(pts[i][0], pts[i][1], pts[i + 1][0], pts[i + 1][1], C.e, 3); ctx.globalAlpha = 1;
  for (let i = 0; i < n; i++) pline(pts[i][0], pts[i][1], pts[i + 1][0], pts[i + 1][1], C.e, 1);
  for (let i = 1; i < n; i += 2) pline(pts[i][0], pts[i][1], pts[i + 1][0], pts[i + 1][1], C.ew, 1);
}
const FIRE = [C.w, C.cream, C.amb, C.o2, C.o, C.od];
function render(){
  const sh = (!RM && S.shake > 0) ? S.shake * 6 : 0;
  ctx.save();
  if (sh) ctx.translate(Math.round(rnd(-sh, sh)), Math.round(rnd(-sh, sh)));
  ctx.drawImage(SKY, 0, 0);
  for (const s of STARS){ const a = 0.35 + 0.65 * (0.5 + 0.5 * Math.sin(S.t * 1.7 + s.p)); ctx.globalAlpha = a; ctx.fillStyle = '#dfeeff'; ctx.fillRect(s.x, s.y, 1, 1); if (s.s === 2 && a > 0.85){ ctx.fillRect(s.x - 1, s.y, 3, 1); ctx.fillRect(s.x, s.y - 1, 1, 3); } }
  ctx.globalAlpha = 1;
  const mx = 300 - (S.scroll * 0.01) % 40;
  ctx.drawImage(MOONGLOW, mx - 18, 6); ctx.drawImage(MOON, mx, 22);
  layer(FAR, S.scroll * 0.12);
  for (const c of S.cars){ ctx.fillStyle = '#0a1828'; ctx.fillRect(c.x | 0, c.y, 5, 2); ctx.fillStyle = c.dir > 0 ? C.amb : C.r; ctx.fillRect((c.x | 0) + (c.dir > 0 ? 5 : -1), c.y, 1, 1); ctx.fillStyle = c.dir > 0 ? C.r : C.amb; ctx.fillRect((c.x | 0) + (c.dir > 0 ? -1 : 5), c.y + 1, 1, 1); }
  if (S.blimp){ const b = S.blimp, bx = b.x | 0; ctx.drawImage(BLIMP, bx, b.y);
    ctx.save(); ctx.beginPath(); ctx.rect(bx + 19, b.y + 8, 44, 7); ctx.clip();
    const tw = BLIMP_TXT.width, off = (b.tx | 0) % tw; ctx.drawImage(BLIMP_TXT, bx + 19 - off, b.y + 8); ctx.drawImage(BLIMP_TXT, bx + 19 - off + tw, b.y + 8); ctx.restore();
    ctx.globalAlpha = 0.12; ctx.fillStyle = C.amb; ctx.beginPath(); ctx.moveTo(bx + 38, b.y + 22); ctx.lineTo(bx + 44, b.y + 22); ctx.lineTo(bx + 60, b.y + 70); ctx.lineTo(bx + 22, b.y + 70); ctx.fill(); ctx.globalAlpha = 1; }
  // Dunst zwischen den Ebenen
  ctx.fillStyle = 'rgba(30,46,80,.18)'; ctx.fillRect(0, 120, W, 76);
  layer(MID, S.scroll * 0.42);
  layer(STREET, S.scroll);
  layer(LAMPS, S.scroll);
  // Pfützen
  for (const h of S.haz) if (h.kind === 'puddle') drawPuddle(h);
  // Sammelobjekte
  for (const it of S.items){
    const by = Math.round(it.y + Math.sin(it.t * 4 + it.ph) * 1.5);
    if (it.kind === 'pw'){ const P = PW[it.type], hk = it.type === 'bank' ? 'e' : it.type === 'magnet' ? 'r' : it.type === 'charger' ? 'big' : 'o';
      ctx.globalAlpha = 0.7 + 0.3 * Math.sin(S.t * 6); ctx.drawImage(HALO[hk], Math.round(it.x - 15), by - 15); ctx.globalAlpha = 1;
      ctx.drawImage(PWS[it.type], Math.round(it.x - 8), by - 8); continue; }
    const big = it.kind === 'c' || it.kind === 'd';
    const hl = big ? HALO.big : HALO.o; ctx.globalAlpha = big ? 0.75 + 0.25 * Math.sin(S.t * 5) : 0.8; ctx.drawImage(hl, Math.round(it.x - hl.width / 2), Math.round(by - hl.height / 2)); ctx.globalAlpha = 1;
    const spr = it.kind === 'cr2032' ? coinFrames[Math.floor((S.t * 10 + it.ph * 3)) % coinFrames.length] : SPR[it.kind];
    ctx.drawImage(spr, Math.round(it.x - spr.width / 2), Math.round(by - spr.height / 2));
    if (big && Math.sin(S.t * 7 + it.ph) > 0.9){ ctx.fillStyle = C.w; ctx.fillRect(Math.round(it.x + 4), by - 9, 1, 3); ctx.fillRect(Math.round(it.x + 3), by - 8, 3, 1); }
  }
  // Gefahren
  for (const h of S.haz){
    if (h.kind === 'zap'){ const [x1, y1, x2, y2] = zapEnds(h);
      ctx.globalAlpha = 0.5; ctx.drawImage(HALO.e, Math.round(x1 - 15), Math.round(y1 - 15)); ctx.drawImage(HALO.e, Math.round(x2 - 15), Math.round(y2 - 15)); ctx.globalAlpha = 1;
      drawArc(x1, y1, x2, y2, S.t + h.ph);
      ctx.drawImage(EMIT, Math.round(x1 - 5), Math.round(y1 - 5)); ctx.drawImage(EMIT, Math.round(x2 - 5), Math.round(y2 - 5));
      if (!RM && R0() < 0.25){ const u = R0(); S.parts.push({ x: x1 + (x2 - x1) * u, y: y1 + (y2 - y1) * u, vx: rnd(-40, 40), vy: rnd(-40, 10), life: 0.2, max: 0.2, c: C.ew, s: 1 }); }
    } else if (h.kind === 'drone'){
      const dx = Math.round(h.x), dy = Math.round(h.y);
      ctx.globalAlpha = 0.09; ctx.fillStyle = C.r; ctx.beginPath(); ctx.moveTo(dx + 7, dy + 9); ctx.lineTo(dx + 10, dy + 9); ctx.lineTo(dx + 20, dy + 44); ctx.lineTo(dx - 3, dy + 44); ctx.fill(); ctx.globalAlpha = 1;
      ctx.drawImage(DRONE, dx, dy);
      const f = Math.floor(S.t * 30) % 2; ctx.fillStyle = C.gl; if (f){ ctx.fillRect(dx, dy + 2, 7, 1); ctx.fillRect(dx + 10, dy + 2, 7, 1); } else { ctx.fillRect(dx + 2, dy + 2, 3, 1); ctx.fillRect(dx + 12, dy + 2, 3, 1); }
      const blink = Math.sin(S.t * 8 + h.ph) > 0; ctx.fillStyle = blink ? C.r : C.rd; ctx.fillRect(dx + 7, dy + 5, 3, 2); if (blink){ ctx.globalAlpha = 0.6; ctx.drawImage(HALO.r, dx - 6, dy - 9); ctx.globalAlpha = 1; }
    }
  }
  // Laser
  for (const l of S.lasers){
    ctx.drawImage(LEMIT, 0, l.y - 6); ctx.save(); ctx.scale(-1, 1); ctx.drawImage(LEMIT, -W, l.y - 6); ctx.restore();
    if (l.t < l.warn){
      if (Math.floor(l.t * 8) % 2 === 0){ ctx.fillStyle = 'rgba(255,46,77,.55)'; for (let x = 10; x < W - 10; x += 8) ctx.fillRect(x, l.y, 4, 1); }
      const wx = W - 22, wy = l.y - 16; ctx.fillStyle = C.r; ctx.beginPath(); ctx.moveTo(wx + 6, wy); ctx.lineTo(wx + 12, wy + 11); ctx.lineTo(wx, wy + 11); ctx.fill(); T('!', wx + 4, wy + 3, C.k);
    } else {
      ctx.globalAlpha = 0.3; ctx.fillStyle = C.r; ctx.fillRect(7, l.y - 3, W - 14, 7); ctx.globalAlpha = 1;
      ctx.fillStyle = C.r; ctx.fillRect(7, l.y - 1, W - 14, 3); ctx.fillStyle = '#ffd0d8'; ctx.fillRect(7, l.y, W - 14, 1);
    }
  }
  // Partikel hinter der Figur (Flamme)
  for (const q of S.parts){ if (q.c !== 'fire') continue; const k = 1 - q.life / q.max; ctx.fillStyle = FIRE[Math.min(FIRE.length - 1, Math.floor(k * FIRE.length))]; ctx.fillRect(Math.round(q.x), Math.round(q.y), q.s, q.s); }
  drawPlayer();
  for (const q of S.parts){ if (q.c === 'fire') continue; ctx.globalAlpha = Math.max(0, q.life / q.max); ctx.fillStyle = q.c; if (q.streak) ctx.fillRect(Math.round(q.x), Math.round(q.y), 6, 1); else ctx.fillRect(Math.round(q.x), Math.round(q.y), q.s, q.s); }
  ctx.globalAlpha = 1;
  // Regen
  ctx.fillStyle = 'rgba(150,200,255,.26)'; for (const d of S.rain){ ctx.fillRect(d.x | 0, d.y | 0, 1, d.l | 0); }
  if (S.ring){ const k = S.ring.t / 0.45; ctx.globalAlpha = 1 - k; ctx.strokeStyle = S.ring.c; ctx.lineWidth = 1; ctx.beginPath(); ctx.arc(Math.round(S.ring.x) + 0.5, Math.round(S.ring.y) + 0.5, 4 + k * 22, 0, Math.PI * 2); ctx.stroke(); ctx.globalAlpha = 1; }
  for (const q of S.pops){ T(q.text, q.x, q.y, q.col, q.sc, q.sc > 1 ? q.col : null, 'c', Math.max(0, 1 - q.t / 1.1)); }
  ctx.restore();
  // Vignette unter die Anzeigen, damit HUD und Titel in den Ecken nicht abdunkeln
  ctx.drawImage(VIG, 0, 0);
  if (S.state === 'play' || S.state === 'dying' || S.state === 'pause') hud();
  if (S.state === 'title') titleScreen();
  if (S.state === 'pause'){ ctx.fillStyle = 'rgba(4,10,20,.6)'; ctx.fillRect(0, 0, W, H); T('PAUSE', W / 2, 88, C.w, 3, C.o, 'c'); T('P DRÜCKEN ODER TIPPEN ZUM WEITERFLIEGEN', W / 2, 124, C.g, 1, null, 'c'); }
  if (S.flash > 0){ ctx.globalAlpha = S.flash * 0.5; ctx.fillStyle = '#fff3e6'; ctx.fillRect(0, 0, W, H); ctx.globalAlpha = 1; }
}
const VIG = (() => { const [c, x] = mk(W, H); const g = x.createRadialGradient(W / 2, H / 2, H * 0.45, W / 2, H / 2, W * 0.62); g.addColorStop(0, 'rgba(0,0,0,0)'); g.addColorStop(1, 'rgba(2,6,12,.55)'); x.fillStyle = g; x.fillRect(0, 0, W, H); return c; })();
function drawPuddle(h){
  const x = Math.round(h.x), y = GROUND + 4;
  ctx.fillStyle = '#04101c'; ctx.fillRect(x + 4, y, h.w - 8, 1); ctx.fillRect(x, y + 1, h.w, 3); ctx.fillRect(x + 4, y + 4, h.w - 8, 1);
  ctx.fillStyle = 'rgba(255,76,41,.45)'; ctx.fillRect(x + 6, y + 2, 8, 1); ctx.fillStyle = 'rgba(89,220,255,.5)'; ctx.fillRect(x + h.w - 14, y + 2, 6, 1);
  ctx.globalAlpha = 0.5; ctx.drawImage(HALO.e, x + h.w / 2 - 15, y - 14); ctx.globalAlpha = 1;
  if (Math.floor(S.t * 12 + h.x) % 3 === 0){ const sx = x + 4 + (R0() * (h.w - 8) | 0); pline(sx, y, sx + 2, y - 4, C.e); pline(sx + 2, y - 4, sx, y - 7, C.ew); }
  if (!RM && R0() < 0.3) S.parts.push({ x: x + R0() * h.w, y: y, vx: rnd(-20, 20), vy: rnd(-60, -20), life: 0.25, max: 0.25, c: R0() < 0.5 ? C.e : C.ew, s: 1 });
}
function drawPlayer(){
  const p = S.p; if (p.inv > 0 && Math.floor(S.t * 16) % 2) return;
  let pose = 'fly';
  if (S.state === 'play' && p.ground) pose = Math.floor(p.run * 5) % 2 ? 'run1' : 'run0';
  else if (p.vy > 70 && !S.thrust) pose = 'fall';
  if (S.state === 'dying') pose = 'fall';
  const px = Math.round(p.x), py = Math.round(p.y);
  // Düsenkern
  const flaming = (S.state === 'title') || (S.state === 'play' && S.thrust && S.energy > 0);
  if (flaming){ const fl = 2 + (R0() * 4 | 0); ctx.fillStyle = C.o; ctx.fillRect(px + 5, py + 23, 4, fl + 1); ctx.fillStyle = C.amb; ctx.fillRect(px + 6, py + 23, 2, fl); ctx.fillStyle = C.w; ctx.fillRect(px + 6, py + 23, 2, 1); }
  else if (S.state === 'play' && !p.ground && R0() < 0.2){ S.parts.push({ x: px + 7, y: py + 24, vx: -20, vy: 20, life: 0.2, max: 0.2, c: '#5b6f84', s: 1 }); }
  if (p.turbo > 0){ ctx.globalAlpha = 0.5; ctx.drawImage(HALO.big, px - 3, py - 4); ctx.globalAlpha = 1; }
  ctx.drawImage(akkunaut(p.face, pose), px, py);
  if (p.shield){ ctx.globalAlpha = 0.55 + 0.25 * Math.sin(S.t * 6); ctx.strokeStyle = C.o; ctx.lineWidth = 1; ctx.beginPath();
    for (let i = 0; i <= 6; i++){ const a = i / 6 * Math.PI * 2 + S.t * 0.6, rr = 19; const xx = px + 15 + Math.cos(a) * rr, yy = py + 14 + Math.sin(a) * rr; i ? ctx.lineTo(xx, yy) : ctx.moveTo(xx, yy); }
    ctx.stroke(); ctx.globalAlpha = 0.1; ctx.fillStyle = C.o; ctx.fill(); ctx.globalAlpha = 1; }
  if (p.magnet > 0){ ctx.globalAlpha = 0.18 + 0.1 * Math.sin(S.t * 10); ctx.strokeStyle = C.r; ctx.beginPath(); ctx.arc(px + 15, py + 14, 30 + (S.t * 40) % 18, 0, Math.PI * 2); ctx.stroke(); ctx.globalAlpha = 1; }
}
/* HUD: Akkurando-Logo (Original-Vektor, auf 14 px Höhe sauber gerastert) + Segment-Tankanzeige.
   Farbe nach Füllstand: voll grün → gelb → orange → rot, unter 20 % rot blinkend. Blau = Powerbank aktiv. */
const lerp = (a, b, t) => a + (b - a) * t;
function mix(c1, c2, t){ const h = (c) => [1, 3, 5].map(i => parseInt(c.slice(i, i + 2), 16)); const A = h(c1), B = h(c2); return '#' + A.map((v, i) => Math.round(lerp(v, B[i], t)).toString(16).padStart(2, '0')).join(''); }
function levelColor(e){
  const stops = [[0, '#ff2e4d'], [20, '#ff2e4d'], [40, '#ff4c29'], [60, '#ffb24a'], [80, '#3ddc84'], [100, '#3ddc84']];
  for (let i = 1; i < stops.length; i++){ if (e <= stops[i][0]){ const [a, ca] = stops[i - 1], [b, cb] = stops[i]; return mix(ca, cb, b === a ? 0 : (e - a) / (b - a)); } }
  return '#3ddc84';
}
function hud(){
  const e = clamp(S.energy, 0, 100), low = e < 20, blink = Math.floor(S.t * 4) % 2 === 0;
  const x = 34, y = 8, w = 44, h = 13;
  ctx.fillStyle = 'rgba(4,10,20,.6)'; ctx.fillRect(5, y - 3, 116, h + 6);
  if (LOGO.hud) ctx.drawImage(LOGO.hud, 8, y - 0);
  ctx.fillStyle = C.k; ctx.fillRect(x - 1, y - 1, w + 5, h + 2);
  ctx.fillStyle = '#cfe0ef'; ctx.fillRect(x, y, w, 1); ctx.fillRect(x, y + h - 1, w, 1); ctx.fillRect(x, y, 1, h); ctx.fillRect(x + w - 1, y, 1, h); ctx.fillRect(x + w, y + 4, 2, h - 8);
  ctx.fillStyle = '#081627'; ctx.fillRect(x + 1, y + 1, w - 2, h - 2);
  const base = S.p.bank > 0 ? C.e : low ? (blink ? C.r : C.rd) : levelColor(e);
  const hi = mix(base, '#ffffff', 0.35), sh = mix(base, '#000000', 0.3);
  for (let i = 0; i < 10; i++){
    const lit = e > i * 10 + 1, cx = x + 2 + i * 4;
    if (!lit){ ctx.fillStyle = '#13283f'; ctx.fillRect(cx, y + 2, 3, h - 4); continue; }
    ctx.fillStyle = base; ctx.fillRect(cx, y + 2, 3, h - 4);
    ctx.fillStyle = hi; ctx.fillRect(cx, y + 2, 3, 2);
    ctx.fillStyle = sh; ctx.fillRect(cx, y + h - 4, 3, 2);
  }
  ctx.fillStyle = C.w; const bx = x + w / 2 - 2; if (S.p.turbo > 0 || S.flash > 0.1){ ctx.fillRect(bx + 2, y + 3, 1, 3); ctx.fillRect(bx + 1, y + 5, 3, 1); ctx.fillRect(bx, y + 6, 1, 3); }
  const pct = Math.ceil(e) + '%';
  T(pct, x + w + 7, y + 4, C.k); T(pct, x + w + 6, y + 3, low ? (blink ? C.r : '#ff7a8c') : C.w);
  let qy = 26, qx = 7;
  const act = [['charger', S.p.turbo, 3], ['bank', S.p.bank, 8], ['magnet', S.p.magnet, 9]];
  for (const [k, t, tot] of act){ if (t <= 0) continue; ctx.drawImage(PWI[k], qx, qy); ctx.fillStyle = '#13283f'; ctx.fillRect(qx + 10, qy + 3, 18, 2); ctx.fillStyle = PW[k].col; ctx.fillRect(qx + 10, qy + 3, Math.ceil(18 * t / tot), 2); qx += 32; }
  if (S.p.shield){ ctx.drawImage(PWI.shield, qx, qy); }
  ctx.fillStyle = 'rgba(4,10,20,.55)'; ctx.fillRect(W - 96, 5, 91, 33);
  T(fmt(meters()) + ' M', W - 8, 8, C.w, 1, null, 'r');
  T(fmt(S.mah) + ' MAH', W - 8, 18, C.amb, 1, null, 'r');
  T(fmt(score()) + ' PKT', W - 8, 28, C.g, 1, null, 'r');
  if (S.combo >= 3 && S.t - S.lastPick < 0.9) T('KETTE ×' + S.combo, W / 2, 10, C.amb, 1, C.o, 'c');
  if (low && S.state === 'play' && blink) T('AKKU NIEDRIG!', W / 2, 24, C.r, 1, C.r, 'c');
}
function titleScreen(){
  ctx.fillStyle = 'rgba(4,10,20,.38)'; ctx.fillRect(0, 0, W, H);
  if (MODE === '404'){ ctx.fillStyle = 'rgba(255,46,77,.16)'; ctx.fillRect(0, 4, W, 13); ctx.fillStyle = C.r; ctx.fillRect(0, 4, W, 1); ctx.fillRect(0, 16, W, 1);
    T('FEHLER 404 · SEITE NICHT GEFUNDEN · AKKU LEER', W / 2, 7, C.r, 1, C.r, 'c'); }
  // Akkurando-Logo (Original-Vektor, gepixelt)
  if (LOGO.title) ctx.drawImage(LOGO.title, Math.round(W / 2 - 92), 25);
  T('AKKUNAUT', W / 2 + 14, 23, C.o, 3, C.o, 'c');
  T('CHARGE & RUN', W / 2 + 14, 50, C.w, 1, C.amb, 'c');
  // Batterie-Reihe: klein = wenig, groß = viel
  const kinds = ['cr2032', 'aaa', 'aa', 'v9', 'c', 'd'];
  const sprs = kinds.map(k => k === 'cr2032' ? coinFrames[0] : SPR[k]);
  const tw = sprs.reduce((a, c) => a + c.width, 0) + 7 * (sprs.length - 1);
  const pw = 176, px0 = Math.round(W / 2 - pw / 2 + 14);
  ctx.fillStyle = 'rgba(4,10,20,.78)'; ctx.fillRect(px0, 68, pw, 52); ctx.fillStyle = '#16385a'; ctx.fillRect(px0, 68, pw, 1); ctx.fillRect(px0, 119, pw, 1);
  let kx = Math.round(px0 + (pw - tw) / 2);
  sprs.forEach((spr, i) => { const yy = 96 - spr.height + Math.round(Math.sin(S.t * 3 + i) * 1.5); ctx.drawImage(spr, kx, yy); kx += spr.width + 7; });
  T('KLEINE ZELLE = WENIG STROM', px0 + pw / 2, 101, C.g, 1, null, 'c');
  T('GROSSE ZELLE = VIEL STROM', px0 + pw / 2, 110, C.amb, 1, null, 'c');
  ctx.fillStyle = 'rgba(4,10,20,.78)'; ctx.fillRect(0, 140, W, 52);
  if (Math.floor(S.t * 2.2) % 2 === 0) T('LEERTASTE ODER TIPPEN ZUM STARTEN', W / 2, 146, C.amb, 1, C.o, 'c');
  T('HALTEN = SCHUB · LOSLASSEN = SINKEN', W / 2, 162, C.g, 1, null, 'c');
  T(S.best > 0 ? 'DEIN BESTWERT ' + fmt(S.best) : 'SAMMLE BATTERIEN, SONST IST DER AKKU LEER', W / 2, 177, C.cream, 1, null, 'c');
}

/* ---------- Spielende & Bestenliste ---------- */
const LB_KEY = 'akkunaut-top20-v1';
const LB_URL = root.dataset.lbUrl || '';
function lbLocal(){ try { const a = JSON.parse(localStorage.getItem(LB_KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
function lbSave(a){ try { localStorage.setItem(LB_KEY, JSON.stringify(a)); } catch (e) {} }
function lbClean(a){ return (Array.isArray(a) ? a : []).filter(e => e && typeof e.name === 'string' && isFinite(e.score)).map(e => ({ id: String(e.id || ''), name: String(e.name).slice(0, 12), score: Math.max(0, Math.floor(+e.score)), m: Math.max(0, Math.floor(+e.m || 0)) })).sort((p, q) => q.score - p.score).slice(0, 20); }
let LB = lbClean(lbLocal());
function lbLoad(){ return LB; }
function lbFetch(){
  if (!LB_URL || !window.fetch) return;
  fetch(LB_URL, { headers: { accept: 'application/json' } }).then(r => r.ok ? r.json() : Promise.reject(r.status))
    .then(j => { LB = lbClean(j && j.entries); renderLB(); })
    .catch(() => { const n = $('lbNote'); if (n) n.textContent = 'Die gemeinsame Bestenliste ist gerade nicht erreichbar. Neue Einträge werden vorerst in diesem Browser gespeichert.'; });
}
function qualifies(sc){ const a = lbLoad(); return sc > 0 && (a.length < 20 || sc > a[a.length - 1].score); }
let lastEntry = null, pending = null;
function renderLB(){
  const a = lbLoad(), ol = $('lb'); ol.innerHTML = '';
  if (!a.length){ const li = document.createElement('li'); li.className = 'akg-lb__empty'; li.textContent = 'Noch keine Einträge. Flieg los und sichere dir Platz 1.'; ol.appendChild(li); return; }
  a.forEach((e, i) => {
    const li = document.createElement('li'); if (lastEntry && e.id === lastEntry) li.className = 'is-me';
    const rk = document.createElement('span'); rk.className = 'akg-lb__rk'; rk.textContent = (i + 1) + '.';
    const nm = document.createElement('span'); nm.className = 'akg-lb__nm'; nm.textContent = e.name;
    const pt = document.createElement('span'); pt.className = 'akg-lb__pt'; pt.textContent = fmt(e.score); const sm = document.createElement('small'); sm.textContent = fmt(e.m) + ' m'; pt.appendChild(sm);
    li.append(rk, nm, pt); ol.appendChild(li);
  });
}
const BLOCK = ['arsch', 'fick', 'fuck', 'hure', 'nazi', 'hitler', 'fotze', 'wichs', 'schlampe', 'bitch', 'penis', 'cunt', 'nigg', 'spast', 'behindert', 'porn', 'sieg heil', 'kanake', 'schwuchtel', 'missgeburt'];
function cleanName(s){ return s.replace(/[^A-Za-z0-9ÄÖÜäöüß _\-.]/g, '').replace(/\s+/g, ' ').trim().slice(0, 12); }
function gameOver(){
  S.state = 'over';
  const sc = score(); const m = meters();
  if (sc > S.best){ S.best = sc; try { localStorage.setItem('akkunaut-best', String(sc)); } catch (e) {} }
  pending = { score: sc, m, mah: S.mah };
  const r = $('ovReason'); r.textContent = S.cause === 'empty' ? 'Akku leer' : 'Kurzschluss!'; r.classList.toggle('empty', S.cause === 'empty');
  $('ovScore').textContent = fmt(sc); $('ovM').textContent = fmt(m) + ' m'; $('ovMah').textContent = fmt(S.mah) + ' mAh'; $('ovBest').textContent = fmt(S.best);
  const q = qualifies(sc); $('ovForm').hidden = !q; $('ovErr').hidden = true; $('ovRank').hidden = true;
  let saved = ''; try { saved = localStorage.getItem('akkunaut-name') || ''; } catch (e) {}
  $('ovName').value = saved;
  $('over').hidden = false;
  if (q) setTimeout(() => $('ovName').focus({ preventScroll: true }), 50); else $('ovAgain').focus({ preventScroll: true });
}
function hideOver(){ $('over').hidden = true; }
$('ovForm').addEventListener('submit', (ev) => {
  ev.preventDefault(); if (!pending) return;
  const name = cleanName($('ovName').value), err = $('ovErr');
  if (name.length < 2){ err.textContent = 'Bitte gib mindestens 2 Zeichen ein.'; err.hidden = false; return; }
  if (BLOCK.some(b => name.toLowerCase().replace(/[^a-zäöüß]/g, '').includes(b.replace(' ', '')))){ err.textContent = 'Bitte wähle einen anderen Namen.'; err.hidden = false; return; }
  const entry = { id: Date.now().toString(36) + Math.random().toString(36).slice(2, 6), name, score: pending.score, m: pending.m, mah: pending.mah, d: new Date().toISOString().slice(0, 10) };
  try { localStorage.setItem('akkunaut-name', name); } catch (e) {}
  const btn = $('ovForm').querySelector('button'); btn.disabled = true;
  const done = (rank, note) => {
    btn.disabled = false; lastEntry = entry.id; pending = null; renderLB();
    $('ovForm').hidden = true; const rk = $('ovRank'); rk.textContent = rank ? 'Eingetragen: Platz ' + rank + ' von 20.' + (note || '') : 'Eingetragen.' + (note || ''); rk.hidden = false;
    $('ovAgain').focus({ preventScroll: true });
  };
  const local = (note) => {
    const a = lbLocal(); a.push(entry); a.sort((p, q) => q.score - p.score); const top = a.slice(0, 20); lbSave(top);
    LB = LB_URL ? lbClean(LB.concat([entry])) : lbClean(top);
    done(LB.findIndex(e => e.id === entry.id) + 1, note);
  };
  if (!LB_URL || !window.fetch) return local();
  fetch(LB_URL, { method: 'POST', headers: { 'content-type': 'application/json', accept: 'application/json' }, body: JSON.stringify({ id: entry.id, name, score: entry.score, m: entry.m, mah: entry.mah }) })
    .then(r => r.ok ? r.json() : Promise.reject(r.status))
    .then(j => { LB = lbClean(j && j.entries); const i = LB.findIndex(e => e.id === entry.id); done(j && j.rank ? j.rank : i + 1); })
    .catch(() => local(' (Server nicht erreichbar – vorerst nur in diesem Browser gespeichert.)'));
});
$('ovAgain').addEventListener('click', start);

/* ---------- Steuerung ---------- */
function press(){
  if (S.state === 'title'){ start(); S.thrust = true; return; }
  if (S.state === 'pause'){ S.state = 'play'; return; }
  if (S.state === 'play') S.thrust = true;
}
function release(){ S.thrust = false; }
function togglePause(){ if (S.state === 'play'){ S.state = 'pause'; S.thrust = false; } else if (S.state === 'pause') S.state = 'play'; updateBtns(); }
/* ---------- Vollbild: am Handy quer spielen ----------
   Echtes Vollbild (Android, Desktop) mit Querformat-Sperre, wo der Browser sie erlaubt.
   Ohne Vollbild-API (iPhone-Safari) legt sich das Spielfeld per CSS über die Seite; im Hochformat
   dreht es sich um 90° (Klasse akg--full + @media orientation:portrait), man hält das Handy einfach quer.
   Die Steuerung kennt nur Drücken/Loslassen – die Drehung stört die Eingabe deshalb nicht. */
const stageEl = root.querySelector('.akg__stage');
let full = false, realFs = false;
const smallTouch = () => matchMedia('(pointer: coarse)').matches && Math.min(screen.width, screen.height) < 900;
const fsEl = () => document.fullscreenElement || document.webkitFullscreenElement;
/* Im Vollbild zieht das Spielfeld in eine eigene Hülle direkt unter <body>: Shop-Header und Sektionen bilden eigene
   Ebenen (z. B. isolation, transform) und lägen sonst darüber – auf dem iPhone so beobachtet (5.10.2026). */
const home = document.createComment('akg'); let portal = null;
function enterFull(){
  if (full) return;
  full = true; root.classList.add('akg--full'); document.documentElement.classList.add('akg-lock');
  portal = document.createElement('div'); portal.className = 'akg akg--full akg--portal';
  stageEl.parentNode.insertBefore(home, stageEl); portal.appendChild(stageEl); document.body.appendChild(portal);
  const req = stageEl.requestFullscreen || stageEl.webkitRequestFullscreen;
  if (req){
    try {
      realFs = true;
      const pr = req.call(stageEl, { navigationUI: 'hide' });
      const lock = () => { try { const o = screen.orientation; if (o && o.lock) o.lock('landscape').catch(() => {}); } catch (_) {} };
      if (pr && pr.then) pr.then(lock).catch(() => { realFs = false; }); else lock();
    } catch (_) { realFs = false; }
  }
  updateBtns(); cv.focus({ preventScroll: true });
}
function exitFull(){
  if (!full) return;
  full = false; root.classList.remove('akg--full'); document.documentElement.classList.remove('akg-lock');
  if (home.parentNode){ home.parentNode.insertBefore(stageEl, home); home.remove(); }
  if (portal){ portal.remove(); portal = null; }
  if (S.state === 'play'){ S.state = 'pause'; S.thrust = false; }
  if (fsEl()){
    try { const o = screen.orientation; if (o && o.unlock) o.unlock(); } catch (_) {}
    try { (document.exitFullscreen || document.webkitExitFullscreen).call(document); } catch (_) {}
  }
  realFs = false; updateBtns();
}
['fullscreenchange', 'webkitfullscreenchange'].forEach(t => document.addEventListener(t, () => { if (!fsEl() && realFs) exitFull(); }));
cv.addEventListener('pointerdown', (e) => {
  e.preventDefault();
  if (!full && smallTouch() && (S.state === 'title' || S.state === 'over' || S.state === 'pause')) enterFull();
  cv.focus({ preventScroll: true }); try { cv.setPointerCapture(e.pointerId); } catch (_) {} press();
});
['pointerup', 'pointercancel', 'lostpointercapture'].forEach(t => cv.addEventListener(t, release));
cv.addEventListener('contextmenu', (e) => e.preventDefault());
const TYPING = () => { const a = document.activeElement; return a && (/^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) || a.isContentEditable); };
const FOCUSED = () => root.contains(document.activeElement) || (full && stageEl.contains(document.activeElement));
window.addEventListener('keydown', (e) => {
  if (TYPING() || e.ctrlKey || e.metaKey || e.altKey) return;
  if (!FOCUSED() && S.state !== 'play') return;
  if (e.code === 'Space' || e.code === 'ArrowUp' || e.code === 'KeyW'){
    if (S.state === 'over'){ if (!e.repeat && document.activeElement !== $('ovAgain')){ e.preventDefault(); start(); } return; }
    e.preventDefault(); if (!e.repeat) press(); else if (S.state === 'play') S.thrust = true;
  } else if (e.code === 'Escape' && full){ exitFull(); }
  else if (e.code === 'KeyP' || (e.code === 'Escape' && S.state === 'play')){ togglePause(); }
  else if (e.code === 'KeyF'){ full ? exitFull() : enterFull(); }
  else if (e.code === 'KeyM'){ toggleSound(); }
});
window.addEventListener('keyup', (e) => { if (e.code === 'Space' || e.code === 'ArrowUp' || e.code === 'KeyW') release(); });
document.addEventListener('visibilitychange', () => { if (document.hidden && S.state === 'play'){ S.state = 'pause'; S.thrust = false; updateBtns(); } });
window.addEventListener('blur', () => { S.thrust = false; });
function toggleSound(){ AU.on = !AU.on; if (AU.on){ ac(); tone(880, 0.06, 'square', 0.04); } updateBtns(); }
function updateBtns(){ const b = $('btnSound'); b.setAttribute('aria-pressed', AU.on ? 'true' : 'false'); b.textContent = AU.on ? 'Ton an' : 'Ton aus'; $('btnPause').textContent = S.state === 'pause' ? 'Weiter' : 'Pause'; const f = $('btnFull'); if (f) f.textContent = full ? 'Vollbild beenden' : 'Vollbild'; }
$('btnSound').addEventListener('click', toggleSound);
$('btnFull').addEventListener('click', () => { full ? exitFull() : enterFull(); });
$('btnExit').addEventListener('click', (e) => { e.stopPropagation(); exitFull(); });
$('btnExit').addEventListener('pointerdown', (e) => e.stopPropagation());
$('btnPause').addEventListener('click', () => { if (S.state === 'play' || S.state === 'pause') togglePause(); });

/* ---------- Legende unter dem Spiel ---------- */
function legendItem(ul, sprite, title, sub, val){
  const li = document.createElement('li'); const c = document.createElement('canvas'); c.width = 22; c.height = 22; const x = c.getContext('2d'); x.imageSmoothingEnabled = false;
  x.drawImage(sprite, Math.round((22 - sprite.width) / 2), Math.round((22 - sprite.height) / 2));
  const d = document.createElement('div'); const b = document.createElement('b'); b.textContent = title; const s = document.createElement('span'); s.innerHTML = sub;
  if (val){ const v = document.createElement('span'); v.className = 'v'; v.textContent = val; d.append(b, v, s); } else d.append(b, s);
  li.append(c, d); ul.appendChild(li);
}
(() => {
  const ul = $('legBatt');
  [['cr2032', 'sehr häufig'], ['aaa', 'häufig'], ['aa', 'regelmäßig'], ['v9', 'gibt kurz Turbo'], ['c', 'selten'], ['d', 'sehr selten']].forEach(([k, note]) => {
    const b = BAT[k]; legendItem(ul, k === 'cr2032' ? coinFrames[0] : SPR[k], b.label, 'ca. ' + fmt(b.mah) + ' mAh · ' + note, '+' + String(b.pct).replace('.', ',') + ' % Akku');
  });
  const up = $('legPw'); Object.keys(PW).forEach(k => legendItem(up, PWS[k], PW[k].name, PW[k].text));
  const hz = $('legHz');
  legendItem(hz, EMIT, 'Lichtbogen', 'Strom zwischen zwei Polen. Nicht durchfliegen.');
  legendItem(hz, DRONE, 'Wachdrohne', 'Schwebt auf und ab. Ausweichen.');
  legendItem(hz, LEMIT, 'Überspannungs-Laser', 'Erst blinkt die Warnung, dann feuert er.');
  const [pc, px] = mk(18, 8); px.fillStyle = '#0e2a40'; px.fillRect(2, 2, 14, 4); px.fillStyle = C.e; px.fillRect(6, 0, 1, 3); px.fillRect(7, 1, 1, 1); px.fillStyle = C.o; px.fillRect(4, 3, 3, 1);
  legendItem(hz, pc, 'Kurzschluss-Pfütze', 'Nur am Boden gefährlich. Drüberfliegen.');
})();
renderLB(); updateBtns();

/* ---------- Schleife: läuft nur, solange das Spielfeld sichtbar ist ---------- */
let last = 0, raf = 0, seen = true;
function frame(now){
  const dt = Math.min(0.05, (now - last) / 1000); last = now;
  update(dt); render(); raf = requestAnimationFrame(frame);
}
function run(){ if (!raf){ raf = requestAnimationFrame((t) => { last = t; frame(t); }); } }
function halt(){ if (raf){ cancelAnimationFrame(raf); raf = 0; } }
if ('IntersectionObserver' in window){
  new IntersectionObserver((es) => {
    seen = es[es.length - 1].isIntersecting;
    if (seen) run(); else { if (S.state === 'play'){ S.state = 'pause'; S.thrust = false; updateBtns(); } render(); halt(); }
  }, { threshold: 0.15 }).observe(cv);
}
document.addEventListener('visibilitychange', () => { if (document.hidden) halt(); else if (seen) run(); });
window.AKG = { play: () => { enterFull(); if (S.state === 'over'){ hideOver(); S.state = 'title'; } updateBtns(); run(); } };
lbFetch();
run();
document.dispatchEvent(new CustomEvent('akg:ready'));
})();
